/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $ajax from './_ajax'
import * as $flag from './_flag'
import * as $form from './_form'
import * as $geo from './geo'
import * as $helpers from './_helpers'
import * as $help from './help'
import * as $loading from './_loading'
import * as $maps from './_maps'
import * as $modal from './_modal'
import * as $msg from './_msg'
import * as $resources from './_resources'
import * as $search from './_search'
import * as $ubh from './_uniformboxheights'
import * as $blogpostpopup from './blog.blogpostpopup'

export module common {
    export interface IInitOptions {
        pageName: string
        pagePrefix: string
        countUrl: string
        listUrl: string
        defaultColumns: number[]
        mandatoryColumns: number[]
        searchPhone: boolean
        searchOrgno: boolean
        searchUtbonarbo: boolean
        searchFunctionAnimals: boolean
        searchFunctionCultivation: boolean
        searchFunctionVehicle: boolean
        searchFelling: boolean
        searchEuSupport: boolean
        searchCompanyType: boolean
        searchTrade: boolean
        searchDistrict: boolean
        searchTransfer: boolean
        searchPropertyOwnedPart: boolean
        searchVehicles: boolean
        searchBuildings: boolean
        searchTaxValue: boolean
        searchSex: boolean
        fetchSearchId: -1
    }

    export var formFields: JQuery[] = []
    export var formFieldsReset: JQuery[] = []
    export var formCheckboxes: JQuery[] = []
    export var formCheckboxesReset: JQuery[] = []
    export var formRanges: any[] = []
    export var formSliders: JQuery[] = []
    export var formFlags: JQuery[] = []
    export var formCustomFields: any[] = []
    export var formCustomFieldsLoad: any[] = []
    export var formCustomFieldsReset: any[] = []

    export var currentPage: number = 1
    export var displayedRowsPerPage: string = ''
    export var sortId: number = 0
    export var sortAsc: boolean = true
    export var mapVisible: boolean = false
    export var largeMap: boolean = false
    export var startPage: number = 1
    var criteriasExpanded: boolean = false
    var manualColumnSelect: boolean = false
    var debugMode: boolean = false
    export var debounceDelay: number = 50
    var callQueue: JQuery = $({})
    var fetchQueue: JQuery = $({})
    export var selectedRegions: string[] = []
    export var selectedCounties: string[] = []
    export var selectedDistricts: string[] = []
    var currentClickedRegion: string = '-1'
    var currentClickedCounty: string = '-1'

    export var options: IInitOptions

    export function init(): void {
        common.elemByClass('reset').click(function() {
            const btn: JQuery = $(this)
            common.resetSearch()
            common.resetLatestSearch(btn.attr('data-section'))
        })

        $('.' + options.pageName + ' .panel-group .panel-heading').click(function() {
            setTimeout(() => {
                const states = []
                $('.' + options.pageName + ' .panel-group').each(function() {
                    states.push({
                        id: $(this).attr('id'),
                        exp: $(this).find('.panel-collapse').hasClass('in'),
                    })
                })
                console.log(states)
                localStorage.setItem('searchpanels_' + options.pageName, JSON.stringify(states))
            }, 1000)
        })

        const loadedPanelStates = JSON.parse(localStorage.getItem('searchpanels_' + options.pageName))
        if (loadedPanelStates) {
            ; (loadedPanelStates as Array<any>).map((state) => {
                const elem = $('#' + state.id)
                if (state.exp) {
                    elem.find('.panel-collapse').removeClass('collapse').addClass('in')
                    elem.find('.panel-title a').removeClass('collapsed')
                } else {
                    elem.find('.panel-collapse').addClass('collapse').removeClass('in')
                    elem.find('.panel-title a').addClass('collapsed')
                }
            })
        }

        common.elem('region').on('change', function() {
            common.fetchCounty(function() {
                if (common.options.searchDistrict) {
                    elem('district-county-name').html('')
                    fetchDistricts(common.elem('county').val())
                }
            })
        })

        if (common.options.searchDistrict) {
            common.elem('county').on('change', function() {
                var countyId: number = parseInt(common.elem('county').val())

                if (countyId > 0) {
                    elem('district-county-name').html($form.getSelectOptionText(common.elem('county')))
                    elem('district-map-icon').attr('data-id', common.elem('county').val())
                } else {
                    elem('district-county-name').html('')
                    elem('district-map-icon').attr('data-id', '-1')
                }

                fetchDistricts(common.elem('county').val())
            })
        }

        // select columns
        elemByClass('columns-toggle-btn').click(function() {
            elemByClass('columns-toggle').toggleClass('bcfla-hidden')
            elem('columns-label').toggleClass('bcfla-hidden')
            elem('columns').toggleClass('bcfla-hidden')
        })
        elem('columns')
            .find('button')
            .click(function() {
                manualColumnSelect = true
                updateColumnsLabel()
            })
        elemByClass('columns-fav-get').click(() => {
            getFavoriteColumns()
        })
        elemByClass('columns-fav-set').click(() => {
            saveFavoriteColumns()
        })

        elem('submit').click(function() {
            if ($('.bcfla-form-group-btn--fixed').length > 0) {
                $helpers.scroll.scrollToElement(elem('results'))
            }

            getList(1)
        })

        elem('region-to-single').click(function() {
            elem('region-section-multi').addClass('search-section-disabled').hide()
            elem('region-section-single').removeClass('search-section-disabled').show()

            common.count(common.elem('region'), /*forceCount*/ true)
            common.count(common.elem('county'), /*forceCount*/ true)
        })

        elem('region-to-multi').click(function() {
            elem('region-section-multi').removeClass('search-section-disabled').show()
            elem('region-section-single').addClass('search-section-disabled').hide()

            common.count(common.elem('regionmulti-searchfor-list'), /*forceCount*/ true)
            common.count(common.elem('countymulti-searchfor-list'), /*forceCount*/ true)
        })

        elem('region-map-icon-multi').click(function() {
            $modal.load(
                '/Geo/RegionsMapForSearch',
                {
                    selectedRegions: selectedRegions.join(','),
                    pagePrefix: options.pagePrefix,
                    multi: true,
                },
                true,
                true,
            )
        })

        elem('region-map-icon-single').click(function() {
            var regionId: number = parseInt(elem('region').val())
            $modal.load(
                '/Geo/RegionsMapForSearch',
                {
                    selectedRegions: regionId,
                    pagePrefix: options.pagePrefix,
                    multi: false,
                },
                true,
                true,
            )
        })

        elem('county-map-icon').click(function() {
            var regionId: number = parseInt(elem('region').val())
            if (regionId <= 0) return
            $modal.load(
                '/Geo/CountyMapForSearch',
                {
                    regionId: regionId,
                    pagePrefix: options.pagePrefix,
                    multi: false,
                },
                true,
                true,
            )
        })

        elem('district-map-icon').click(function() {
            var countyId: number = parseInt($(this).attr('data-id'))
            if (countyId <= 0) return
            $modal.load(
                '/Geo/DistrictMapForSearch',
                {
                    countyId: countyId,
                    pagePrefix: options.pagePrefix,
                    selectedDistricts: selectedDistricts.join(','),
                },
                true,
                true,
                true,
            )
        })

        elem('district-selectall').click(function() {
            elem('district-searchresult-list li .icon').each(function() {
                var id: string = $(this).parent().attr('data-id')
                var disabled: boolean = $(this).parent().hasClass('disabled')
                if (id == '-1' || disabled) return
                selectedDistricts.push(id)
            })

            elem('district-searchfor-list').attr('data-value', selectedDistricts.join(','))

            fetchDistricts(currentClickedCounty, function() {
                count(elem('district-searchfor-list'))
            })
        })

        elem('district-clearall').click(function() {
            selectedDistricts = []

            elem('district-searchfor-list').attr('data-value', '')

            fetchDistricts(currentClickedCounty, function() {
                count(elem('district-searchfor-list'))
            })
        })

        elem('countymulti-selectall').click(function() {
            elem('countymulti-searchresult-list li .icon').each(function() {
                var id: string = $(this).parent().attr('data-id')
                var disabled: boolean = $(this).parent().hasClass('disabled')
                if (id == '-1' || disabled) return
                selectedCounties.push(id)
            })

            common.elem('countymulti-searchfor-list').attr('data-value', selectedCounties.join(','))

            fetchCounties(currentClickedRegion, function() {
                common.count(common.elem('countymulti-searchfor-list'))
            })
        })

        elem('countymulti-clearall').click(function() {
            selectedCounties = []

            elem('countymulti-searchfor-list').attr('data-value', '')

            fetchCounties(currentClickedRegion, function() {
                common.count(common.elem('countymulti-searchfor-list'))
            })
        })

        elem('savesearch-btn').click(function() {
            saveSearch()
        })

        // ladda sökfråga
        elem('savesearch-list').on('change', function() {
            fetchSavedSearch()
        })

        // fetch latest used rows per page from localstorage if possible
        const rowsFromLocalStorage = localStorage.getItem('rowsperpage')
        if (rowsFromLocalStorage && rowsFromLocalStorage.length > 0) {
            console.log('fetched rows per page from localstorage: ' + rowsFromLocalStorage)
            elem('rows').val(rowsFromLocalStorage)
        }

        // fetch latest used expand sub row from localstorage if possible
        if (common.elem('expandsubrow').length > 0) {
            const expandoFromLocalStorage = localStorage.getItem('expandsubrow')
            if (expandoFromLocalStorage && expandoFromLocalStorage.length > 0) {
                console.log('fetched expandoFromLocalStorage: ' + expandoFromLocalStorage)
                $form.setCheckboxlistValues(common.elem('expandsubrow'), expandoFromLocalStorage)
            }
        }

        selectDefaultColumns()
        updateColumnsLabel()
        loadSavedSearchesDropdown()

        debugMode = $helpers.pageInDebugMode()
    }

    export function fetchRegions(callback: any = null): void {
        var list: JQuery = common.elem('regionmulti-searchfor-list')

        console.log('promise fetch regions')

        Promise.all([
            new Promise<void>((resolve, reject) => {
                $ajax.post({
                    url: '/Search/RegionsList',
                    data: {
                        exclude: selectedRegions.join(','),
                    },
                    dataType: 'html',
                    success: function(res) {
                        common.elem('regionmulti-searchresult-list').html(res)
                        resolve()
                    },
                    error: (xhr: JQueryXHR, textStatus: string, errorThrown: string) => {
                        reject(textStatus)
                    },
                })
            }),
            new Promise<void>((resolve, reject) => {
                $ajax.post({
                    url: '/Search/RegionsListById',
                    data: {
                        ids: selectedRegions.join(','),
                    },
                    dataType: 'html',
                    success: function(res) {
                        common.elem('regionmulti-searchfor-list').html(res)
                        resolve()
                    },
                    error: (xhr: JQueryXHR, textStatus: string, errorThrown: string) => {
                        reject(textStatus)
                    },
                })
            }),
        ])
            .then(function() {
                rebindRegionEvents()
                if (callback) callback(list)
            })
            .catch(function(msg: string) {
                $msg.showError(msg)
            })
    }

    export function rebindRegionEvents(): void {
        var listCounties = function() {
            var regionId: string = $(this).parent().attr('data-id')
            elem('countymulti-region-name').html($(this).parent().attr('data-name'))
            fetchCounties(regionId)
        }

        var showCountiesOnMap = function() {
            var regionId: string = $(this).parent().attr('data-id')
            $modal.load(
                '/Geo/CountyMapForSearch',
                {
                    regionId: regionId,
                    selectedCounties: selectedCounties.join(','),
                    pagePrefix: options.pagePrefix,
                    multi: true,
                },
                true,
                true,
                true,
            )

            // fetch counties list here too, so the modal can "talk to" the list here
            fetchCounties(regionId)
        }

        common.elem('regionmulti-searchresult-list li .icon--county').off('click')
        common.elem('regionmulti-searchresult-list li .icon--county').on('click', listCounties)

        common.elem('regionmulti-searchfor-list li .icon--county').off('click')
        common.elem('regionmulti-searchfor-list li .icon--county').on('click', listCounties)

        common.elem('regionmulti-searchresult-list li .icon--map').off('click')
        common.elem('regionmulti-searchresult-list li .icon--map').on('click', showCountiesOnMap)

        common.elem('regionmulti-searchfor-list li .icon--map').off('click')
        common.elem('regionmulti-searchfor-list li .icon--map').on('click', showCountiesOnMap)

        common.elem('regionmulti-searchresult-list li .icon--add').off('click')
        common.elem('regionmulti-searchresult-list li .icon--add').on('click', function() {
            var id: string = $(this).parent().attr('data-id')
            var disabled: boolean = $(this).parent().hasClass('disabled')
            if (id == '-1' || disabled) return

            console.log('> ' + id)

            selectedRegions.push(id)

            common.elem('regionmulti-searchfor-list').attr('data-value', selectedRegions.join(','))

            fetchRegions(function() {
                common.count(common.elem('regionmulti-searchfor-list'))
            })
        })

        common.elem('regionmulti-searchfor-list li .icon--add').off('click')
        common.elem('regionmulti-searchfor-list li .icon--add').on('click', function() {
            var id: string = $(this).parent().attr('data-id')

            console.log('< ' + id)

            selectedRegions = _.without(selectedRegions, id)

            common.elem('regionmulti-searchfor-list').attr('data-value', selectedRegions.join(','))

            fetchRegions(function() {
                common.count(common.elem('regionmulti-searchfor-list'))
            })
        })
    }

    function fetchCounties(regionId: string, callback: any = null): void {
        currentClickedRegion = regionId
        var list: JQuery = common.elem('countymulti-searchfor-list')

        Promise.all([
            new Promise<void>((resolve, reject) => {
                $ajax.post({
                    url: '/Search/CountiesList',
                    data: {
                        regionId: regionId,
                        exclude: selectedCounties.join(','),
                    },
                    dataType: 'html',
                    success: function(res) {
                        common.elem('countymulti-searchresult-list').html(res)
                        resolve()
                    },
                    error: (xhr: JQueryXHR, textStatus: string, errorThrown: string) => {
                        reject(textStatus)
                    },
                })
            }),
            new Promise<void>((resolve, reject) => {
                $ajax.post({
                    url: '/Search/CountiesListById',
                    data: {
                        ids: selectedCounties.join(','),
                    },
                    dataType: 'html',
                    success: function(res) {
                        common.elem('countymulti-searchfor-list').html(res)
                        resolve()
                    },
                    error: (xhr: JQueryXHR, textStatus: string, errorThrown: string) => {
                        reject(textStatus)
                    },
                })
            }),
        ])
            .then(function() {
                rebindCountyEvents()
                if (callback) callback(list)
            })
            .catch(function(msg: string) {
                $msg.showError(msg)
            })
    }

    export function rebindCountyEvents(): void {
        var listDistricts = function() {
            var countyId: string = $(this).parent().attr('data-id')
            elem('district-county-name').html($(this).parent().attr('data-name'))
            elem('district-map-icon').attr('data-id', countyId)
            fetchDistricts(countyId)
        }

        var showDistrictsOnMap = function() {
            var countyId: string = $(this).parent().attr('data-id')
            $modal.load(
                '/Geo/DistrictMapForSearch',
                {
                    countyId: countyId,
                    selectedDistricts: selectedDistricts.join(','),
                    pagePrefix: options.pagePrefix,
                },
                true,
                true,
                true,
            )

            // fetch districts list here too, so the modal can "talk to" the list here
            fetchDistricts(countyId)
        }

        common.elem('countymulti-searchresult-list li .icon--district').off('click')
        common.elem('countymulti-searchresult-list li .icon--district').on('click', listDistricts)

        common.elem('countymulti-searchfor-list li .icon--district').off('click')
        common.elem('countymulti-searchfor-list li .icon--district').on('click', listDistricts)

        common.elem('countymulti-searchresult-list li .icon--map').off('click')
        common.elem('countymulti-searchresult-list li .icon--map').on('click', showDistrictsOnMap)

        common.elem('countymulti-searchfor-list li .icon--map').off('click')
        common.elem('countymulti-searchfor-list li .icon--map').on('click', showDistrictsOnMap)

        common.elem('countymulti-searchresult-list li .icon--add').off('click')
        common.elem('countymulti-searchresult-list li .icon--add').on('click', function() {
            var id: string = $(this).parent().attr('data-id')
            var disabled: boolean = $(this).parent().hasClass('disabled')
            if (id == '-1' || disabled) return

            console.log('> ' + id)

            selectedCounties.push(id)

            common.elem('countymulti-searchfor-list').attr('data-value', selectedCounties.join(','))

            fetchCounties(currentClickedRegion, function() {
                common.count(common.elem('countymulti-searchfor-list'))
            })
        })

        common.elem('countymulti-searchfor-list li .icon--add').off('click')
        common.elem('countymulti-searchfor-list li .icon--add').on('click', function() {
            var id: string = $(this).parent().attr('data-id')

            console.log('< ' + id)

            selectedCounties = _.without(selectedCounties, id)

            common.elem('countymulti-searchfor-list').attr('data-value', selectedCounties.join(','))

            fetchCounties(currentClickedRegion, function() {
                common.count(common.elem('countymulti-searchfor-list'))
            })
        })
    }

    function fetchDistricts(countyId: string, callback: any = null): void {
        currentClickedCounty = countyId
        var list: JQuery = common.elem('district-searchfor-list')

        console.log('promise fetch districts ' + countyId)

        Promise.all([
            new Promise<void>((resolve, reject) => {
                console.log('promise list searchresult')
                $ajax.post({
                    url: '/Search/DistrictsList',
                    data: {
                        countyId: countyId,
                        exclude: selectedDistricts.join(','),
                    },
                    dataType: 'html',
                    success: function(res) {
                        common.elem('district-searchresult-list').html(res)
                        console.log('promise resolve searchresult')
                        resolve()
                    },
                    error: (xhr: JQueryXHR, textStatus: string, errorThrown: string) => {
                        reject(textStatus)
                    },
                })
            }),
            new Promise<void>((resolve, reject) => {
                console.log('promise list searchfor')
                $ajax.post({
                    url: '/Search/DistrictsListById',
                    data: {
                        ids: selectedDistricts.join(','),
                    },
                    dataType: 'html',
                    success: function(res) {
                        common.elem('district-searchfor-list').html(res)
                        console.log('promise resolve searchfor')
                        resolve()
                    },
                    error: (xhr: JQueryXHR, textStatus: string, errorThrown: string) => {
                        reject(textStatus)
                    },
                })
            }),
        ])
            .then(function() {
                console.log('promise then')
                rebindDistrictEvents()
                if (callback) callback(list)
            })
            .catch(function(msg: string) {
                $msg.showError(msg)
            })
    }

    export function rebindDistrictEvents(): void {
        common.elem('district-searchresult-list li .icon').off('click')
        common.elem('district-searchresult-list li .icon').on('click', function() {
            var id: string = $(this).parent().attr('data-id')
            var disabled: boolean = $(this).parent().hasClass('disabled')
            if (id == '-1' || disabled) return

            console.log('> ' + id)

            selectedDistricts.push(id)

            common.elem('district-searchfor-list').attr('data-value', selectedDistricts.join(','))

            fetchDistricts(currentClickedCounty, function() {
                common.count(common.elem('district-searchfor-list'))
            })
        })

        common.elem('district-searchfor-list li .icon').off('click')
        common.elem('district-searchfor-list li .icon').on('click', function() {
            var id: string = $(this).parent().attr('data-id')

            console.log('< ' + id)

            selectedDistricts = _.without(selectedDistricts, id)

            common.elem('district-searchfor-list').attr('data-value', selectedDistricts.join(','))

            fetchDistricts(currentClickedCounty, function() {
                common.count(common.elem('district-searchfor-list'))
            })
        })
    }

    export function setSort(newSort: number, asc: string): void {
        if (newSort != sortId) {
            sortId = newSort
            sortAsc = asc == 'true'
        } else {
            sortAsc = !sortAsc
        }
    }

    export function getList(page: number, extraData: any = null): void {
        var f = (function(page: number, extraData: any) {
            callQueue.queue(function(next) {
                currentPage = page
                var rowsPerPage: string = elem('rows').val()

                if (debugMode && options.listUrl.indexOf('OwnerList') >= 0) {
                    $ajax.post({
                        loadingText: 'Hämtar sökresultat...',
                        url: '/SearchV2/OwnerList',
                        data: {
                            criteriaData: JSON.stringify(serializeForm()),
                            page: page,
                            rowsperpage: rowsPerPage,
                            expandsubrow: $form.getCheckboxlistValues(common.elem('expandsubrow')).join(','),
                            sortId: sortId,
                            sortAsc: sortAsc,
                            totalNo: elem('total-no').html(),
                            expanded: criteriasExpanded,
                            columns: getSelectedColumns(),
                        },
                        dataType: 'html',
                        success: function(res) {
                            displayedRowsPerPage = rowsPerPage
                            elem('results').html(res)
                            common.mapVisible = false
                            if (elem('rows').length > 0) {
                                localStorage.setItem('rowsperpage', elem('rows').val())
                            }
                            if (elem('expandsubrow').length > 0) {
                                localStorage.setItem(
                                    'expandsubrow',
                                    $form.getCheckboxlistValues(common.elem('expandsubrow')).join(','),
                                )
                            }
                        },
                        complete: function() {
                            next()
                        },
                    })
                    return
                }

                $ajax.post({
                    loadingText: 'Hämtar sökresultat...',
                    url: options.listUrl,
                    data: {
                        criteriaData: JSON.stringify(serializeForm()),
                        page: page,
                        rowsperpage: rowsPerPage,
                        expandsubrow: $form.getCheckboxlistValues(common.elem('expandsubrow')).join(','),
                        sortId: sortId,
                        sortAsc: sortAsc,
                        totalNo: elem('total-no').html(),
                        expanded: criteriasExpanded,
                        columns: getSelectedColumns(),
                    },
                    dataType: 'html',
                    success: function(res) {
                        displayedRowsPerPage = rowsPerPage
                        elem('results').html(res)
                        common.mapVisible = false
                        if (elem('rows').length > 0) {
                            localStorage.setItem('rowsperpage', elem('rows').val())
                        }
                        if (elem('expandsubrow').length > 0) {
                            localStorage.setItem(
                                'expandsubrow',
                                $form.getCheckboxlistValues(common.elem('expandsubrow')).join(','),
                            )
                        }
                    },
                    complete: function() {
                        next()
                    },
                })
            })
        })(page, extraData)
    }

    export function serializeForm(): any {
        return $search.serializeForm({
            fields: formFields,
            checkboxes: formCheckboxes,
            ranges: formRanges,
            flags: formFlags,
            customFields: formCustomFields,
        })
    }

    export function resetSearch(): void {
        var resetFields: JQuery[] = $search.reset({
            fields: formFieldsReset,
            checkboxes: formCheckboxesReset,
            sliders: formSliders,
            flags: formFlags,
            customFields: formCustomFieldsReset,
        })

        $.each(resetFields, function() {
            count(this, true)
        })

        elem('results').html('')
        elem('statistics').html('')
    }

    export function initRangeWithSlider(sliderElem: JQuery, minElem: JQuery, maxElem: JQuery): void {
        var countFunction: any = bindCountEventRange(minElem, maxElem)

        minElem.on('blur keyup', function() {
            sliderElem.slider('values', 0, minElem.val())
            sliderElem.slider('values', 1, maxElem.val())
        })

        maxElem.on('blur keyup', function() {
            sliderElem.slider('values', 0, minElem.val())
            sliderElem.slider('values', 1, maxElem.val())
        })

        var minValue = parseInt(sliderElem.attr('data-value-min'))
        var maxValue = parseInt(sliderElem.attr('data-value-max'))

        sliderElem.slider({
            range: true,
            values: [0, 0],
            min: minValue,
            max: maxValue,
            slide: function(event, ui) {
                minElem.val(ui.values[0].toString())
                maxElem.val(ui.values[1].toString())
            },
            stop: function(event, ui) {
                countFunction()
            },
        })
    }

    function bindCountEventRange(thisMinElem: JQuery, thisMaxElem: JQuery): any {
        var debouncedCount = _.debounce(function() {
            count(thisMinElem)
        }, debounceDelay)
        thisMinElem.on('blur', function() {
            debouncedCount()
        })
        thisMaxElem.on('blur', function() {
            debouncedCount()
        })
        thisMinElem.on('keyup', function() {
            debouncedCount()
        })
        thisMaxElem.on('keyup', function() {
            debouncedCount()
        })
        return debouncedCount
    }

    export function bindCountEventTextbox(thisElem: JQuery): any {
        var debouncedCount = _.debounce(function() {
            count(thisElem)
        }, debounceDelay)
        thisElem.on('blur', function() {
            debouncedCount()
        })
        thisElem.on('keyup', function() {
            debouncedCount()
        })
        return debouncedCount
    }

    export function bindCountEventDropdown(thisElem: JQuery): any {
        var debouncedCount = _.debounce(function() {
            count(thisElem)
        }, debounceDelay)
        thisElem.on('change', function() {
            debouncedCount()
        })
        return debouncedCount
    }

    export function bindCountEventCheckbox(thisElem: JQuery): any {
        var debouncedCount = _.debounce(function() {
            count(thisElem)
        }, debounceDelay)
        thisElem.find('button').click(function() {
            debouncedCount()
        })
        return debouncedCount
    }

    export function bindCountEventFlags(thisElem: JQuery): any {
        var debouncedCount = _.debounce(function() {
            count(thisElem)
        }, debounceDelay)
        thisElem.find('span').click(function() {
            $(this).toggleClass('bcfla-label-unchecked')
            $(this).toggleClass('bcfla-checked')
            debouncedCount()
        })
        return debouncedCount
    }

    export function count(criteriaElement: JQuery, forceCount: boolean = false): void {
        var currentCriteriaId: string = criteriaElement.attr('data-criteria-id')

        var f = (function(criteriaElem: JQuery, criteriaId: string) {
            callQueue.queue(function(next) {
                var criteriaData: $search.ICriteriaItem[] = serializeForm()
                var currentCriteriaData: $search.ICriteriaItem = _.find(
                    criteriaData,
                    function(c: $search.ICriteriaItem) {
                        return c.CriteriaId == criteriaId
                    },
                )

                if (
                    !currentCriteriaData ||
                    (currentCriteriaData.Values == currentCriteriaData.PreviousValues && !forceCount)
                ) {
                    next()
                    return
                }

                var antalElem = elem('antal-' + criteriaId)
                //antalElem.text('...')
                //elem('total-no').text('...')
                //elem('total-no-household').text('...')
                //elem('total-no-owner').text('...')
                //elem('total-no-property').text('...')

                panelCount()

                if (debugMode && options.countUrl.indexOf('OwnerCount') >= 0) {
                    $ajax.post({
                        loadingText: 'Räknar...',
                        url: '/SearchV2/OwnerCount',
                        data: {
                            currentCriteriaId: criteriaId,
                            criteriaData: JSON.stringify(criteriaData),
                            all: false,
                            debug: true,
                        },
                        success: function(res) {
                            antalElem.text(res.CurrentCriteriaNo)
                            if (!manualColumnSelect) selectColumns(res.Columns)
                            $search.setPreviousValue(criteriaElem, currentCriteriaData)
                            panelCount()
                        },
                    })

                    $ajax.post({
                        loadingText: 'Räknar...',
                        url: '/SearchV2/OwnerCount',
                        data: {
                            currentCriteriaId: criteriaId,
                            criteriaData: JSON.stringify(criteriaData),
                            all: true,
                            debug: true,
                        },
                        success: function(res) {
                            $helpers.flash(elem('total-no')).text(res.TotalNo)
                            $helpers.flash(elem('total-no-household')).text(res.TotalNoHousehold)
                            $helpers.flash(elem('total-no-owner')).text(res.TotalNoOwner)
                            $helpers.flash(elem('total-no-property')).text(res.TotalNoProperty)
                        },
                        complete: function() {
                            next()
                        },
                    })

                    return
                }

                $ajax.post({
                    loadingText: 'Räknar...',
                    url: options.countUrl,
                    data: {
                        currentCriteriaId: criteriaId,
                        criteriaData: JSON.stringify(criteriaData),
                        all: false,
                        debug: debugMode ? true : null,
                    },
                    success: function(res) {
                        antalElem.text(res.CurrentCriteriaNo)
                        if (!manualColumnSelect) selectColumns(res.Columns)
                        $search.setPreviousValue(criteriaElem, currentCriteriaData)
                        panelCount()
                    },
                    complete: function() {
                        $ajax.post({
                            loadingText: 'Räknar...',
                            url: options.countUrl,
                            data: {
                                currentCriteriaId: criteriaId,
                                criteriaData: JSON.stringify(criteriaData),
                                all: true,
                                debug: debugMode ? true : null,
                            },
                            success: function(res) {
                                $helpers.flash(elem('total-no')).text(res.TotalNo)
                                $helpers.flash(elem('total-no-household')).text(res.TotalNoHousehold)
                                $helpers.flash(elem('total-no-owner')).text(res.TotalNoOwner)
                                $helpers.flash(elem('total-no-property')).text(res.TotalNoProperty)
                            },
                            complete: function() {
                                next()
                            },
                        })
                    },
                })
            })
        })(criteriaElement, currentCriteriaId)
    }

    function panelCount(): void {
        $('.' + options.pageName + ' .panel-default').each(function() {
            var panel: JQuery = $(this)
            var count: number = 0
            panel.find('.' + options.pagePrefix + '-antal-col > div').each(function() {
                var countdiv: JQuery = $(this)
                if (countdiv.html().length > 0) count++
            })

            if (count === 0) panel.find('.panel-heading').removeClass('selected')
            else panel.find('.panel-heading').addClass('selected')

            panel.find('.panel-count').html(count === 0 ? '' : '(' + count + ')')
        })
    }

    export function fetchCounty(callback: any): void {
        $geo.county.getListToDropdown({
            lanId: elem('region').val(),
            fetchAll: true,
            dropdownElem: elem('county'),
            onComplete: function(list) {
                callback(list)
            },
        })
    }

    export function getSelectedColumns(): string {
        var values: string[] = []

        elem('columns')
            .find('button.bcfla-checked')
            .each(function() {
                values.push($(this).attr('data-value'))
            })

        return values.join(',')
    }

    export function selectColumns(columns: number[]): void {
        elem('columns')
            .find('button')
            .each(function() {
                var btn: JQuery = $(this)
                var val: number = parseInt(btn.attr('data-value'))
                if (_.indexOf(columns, val) >= 0) {
                    btn.addClass('bcfla-checked')
                } else if (!btn.prop('disabled')) {
                    btn.removeClass('bcfla-checked')
                }
            })
        updateColumnsLabel()
    }

    function updateColumnsLabel(): void {
        setTimeout(function() {
            var labels: string[] = []
            var ids: string[] = []

            elem('columns')
                .find('button.bcfla-checked')
                .each(function() {
                    labels.push($(this).text())
                    ids.push($(this).attr('data-value'))
                })

            elem('columns-label').html(labels.join(', '))

            // also save columns in localstorage
            console.log('columns save in localstorage: ' + ids.join(','))
            localStorage.setItem('columns_' + options.pageName, ids.join(','))
        }, 250)
    }

    function selectDefaultColumns(): void {
        let columnsToSelect: number[] = options.defaultColumns

        // fetch latest used columns from localstorage if possible
        const columnsFromLocalStorage = localStorage.getItem('columns_' + options.pageName)
        if (columnsFromLocalStorage?.length > 0) {
            columnsToSelect = columnsFromLocalStorage.split(',').map((s) => parseInt(s))
            console.log(
                'columns fetched from localstorage: ' + columnsFromLocalStorage + ' -> ' + columnsToSelect.join(','),
            )
        }

        elem('columns')
            .find('button')
            .each(function() {
                var btn: JQuery = $(this)
                var val: number = parseInt(btn.attr('data-value'))

                if (_.indexOf(columnsToSelect, val) >= 0) {
                    btn.addClass('bcfla-checked')
                } else {
                    btn.removeClass('bcfla-checked')
                }

                btn.prop('disabled', _.indexOf(options.mandatoryColumns, val) >= 0)
            })
        updateColumnsLabel()
    }

    export function saveFavoriteColumns(): void {
        const ids: string = getSelectedColumns()

        console.log('favoritecolumns save in localstorage: ' + ids)
        localStorage.setItem('favcols_' + options.pageName, ids)

        $msg.show('Dina favoritkolumner har sparats!')
    }

    export function getFavoriteColumns(): void {
        const columnsFromLocalStorage = localStorage.getItem('favcols_' + options.pageName)
        if (!columnsFromLocalStorage || !columnsFromLocalStorage.length) {
            $msg.showError('Hittade inga sparade favoritkolumner att hämta upp.')
            return
        }

        console.log('favoritecolumns got from localstorage: ' + columnsFromLocalStorage)

        const columns: number[] = columnsFromLocalStorage.split(',').map((col) => parseInt(col))

        selectColumns(columns)

        $msg.show('Dina favoritkolumner har markerats!')
    }

    export function resetLatestSearch(section: string): void {
        $ajax.post({
            loadingText: 'Nollställer...',
            url: '/Search/ResetLatestFor?section=' + section,
            dataType: 'html',
        })
    }

    export function loadLatestSearch(url: string): void {
        $ajax.post({
            loadingText: 'Hämtar sökfråga...',
            url: url,
            data: { searchId: -1 },
            success: function(res) {
                if (!res || res.Id <= 0) return
                sortId = res.sortId
                sortAsc = res.sortAsc
                startPage = res.page
                manualColumnSelect = true
                selectColumns(res.columns)
                loadSavedSearch(JSON.parse(res.Data))
                setFriendlyFlag20Title()
                setFriendlyFlag20Title('ex')
                setFriendlyFlag20Title('owner')
                setFriendlyFlag20Title('ownerex')
            },
        })
    }

    export function setFriendlyFlag20Title(prefix: string = ''): void {
        console.log('setFriendlyFlag20Title: queueing...')
        fetchQueue.queue(function(next) {
            console.log('setFriendlyFlag20Title: go!')
            var flagidselem = elem(prefix + 'flags20-ids')
            var owner: boolean = flagidselem.attr('data-owner') === 'true'
            var val: string = flagidselem.val()
            console.log('setFriendlyFlag20Title: val: ' + val)
            if (!val || val.length === 0) next()
            else {
                $ajax.post({
                    loadingText: 'Hämtar flaggor...',
                    url: '/Flag/GetFlagStringTitle',
                    data: {
                        owner: owner,
                        flagstring: val,
                        prefix: prefix,
                    },
                    dataType: 'html',
                    success: function(res) {
                        elem(prefix + 'flags20-names').html(res)
                        next()
                    },
                })
                next()
            }
        })
    }

    function updateCountForSavedSearch(id: number): void {
        console.log(`updateCountForSavedSearch(${id}): queueing...`)
        callQueue.queue(function(next) {
            console.log('updateCountForSavedSearch: go!')
            console.log(`updateCountForSavedSearch: spara antal ${elem('total-no').text()} på fråga ${id}`)

            $ajax.post({
                loadingText: 'Sparar antal på sökfråga...',
                url: '/Search/SavedSearchUpdateCount',
                data: {
                    id: id,
                    count: elem('total-no').text(),
                },
                success: function(res) {
                    if (res.Ok) {
                        loadSavedSearchesDropdown()
                    }
                },
            })

            // proceed immediately, no need for the above call to block anything
            next()
        })
    }

    export function loadSavedSearch(searchData: $search.ICriteriaItem[]): void {
        if (!searchData || searchData.length === 0) return

        resetSearch()

        var loadedFields: JQuery[] = $search.deserializeForm({
            criteriaData: searchData,
            fields: formFields,
            ranges: formRanges,
            checkboxes: formCheckboxes,
            flags: formFlags,
            customFields: formCustomFieldsLoad,
        })

        console.log('loadSavedSearch searchData: ' + JSON.stringify(searchData))
        console.log('loadSavedSearch loadedFields:')
        console.log(loadedFields)

        $.each(loadedFields, function() {
            var loadedField: JQuery = this
            var f = (function(field: JQuery) {
                fetchQueue.queue(function(next) {
                    var fieldId: string = field.attr('id')

                    if (fieldId == elem('region').attr('id')) {
                        fetchCounty(function() {
                            next()
                        })
                    } else if (fieldId == elem('county').attr('id')) {
                        if (common.options.searchDistrict)
                            fetchDistricts(common.elem('county').val(), function() {
                                next()
                            })
                        else next()
                    } else {
                        next()
                    }
                })

                fetchQueue.queue(function(next) {
                    var fieldId: string = field.attr('id')
                    if (fieldId == elem('region').attr('id')) {
                        $search.deserializeForm({
                            criteriaData: searchData,
                            fields: [elem('region'), elem('county')],
                        })
                    }
                    next()
                })
            })(loadedField)
        })

        fetchQueue.queue(function(next) {
            $.each(loadedFields, function() {
                count(this, true)
            })
            next()
        })

        console.log('loadedFields: ' + loadedFields.length)

        if (loadedFields.length > 0) {
            console.log('loadedFields.length > 0')
            fetchQueue.queue(function(next) {
                console.log('queue getList(startPage)')
                getList(startPage)
                next()
            })
        }
    }

    function loadSavedSearchesDropdown(): void {
        var ddl = elem('savesearch-list')

        const selected = ddl.val()
        console.log('loadSavedSearchesDropdown', 'currently selected', selected)

        ddl.html('<option>Laddar...</option>')
        ddl.prop('disabled', true)

        $ajax.post({
            loadingText: 'Hämtar sparade sökfrågor...',
            url: '/Search/SavedSearchJsonList',
            data: {
                type: ddl.attr('data-type'),
            },
            success: function(list) {
                list.splice(0, 0, { Id: -1, Name: '-- Välj fråga --' })
                ddl.addSelectOptions(list, 'Id', 'Name')
                $form.selectValue(ddl, selected)
                ddl.prop('disabled', false)
            },
        })
    }

    export function fetchSavedSearch(fetchSearchId: number = -1): void {
        let id = -1

        const ddl = elem('savesearch-list')
        const name = elem('savesearch-name')

        if (fetchSearchId > 0) {
            id = fetchSearchId

            // select item in ddl too
            ddl.val(id.toString())

            // remove id from querystring as soon as it's been fetched
            // this way it won't be fetched again and override the last search in state
            if (history && history.replaceState) {
                history.replaceState(null, null, location.href.toString().replace(/[?&]searchid=\d+/, ''))
            }
        } else {
            id = parseInt(ddl.val())
        }

        if (id <= 0) {
            name.val('')
            return
        }

        let ddlname = $form.getSelectOptionText(ddl)
        ddlname = ddlname.replace(/ \([\d ]+ st\)$/i, '')
        ddlname = $helpers.decodeHtml(ddlname)
        name.val(ddlname)

        $ajax.post({
            loadingText: 'Hämtar sökfråga...',
            url: '/Search/SavedSearchFetch',
            data: { id: id },
            success: function(res) {
                if (res.Resultat.Ok) {
                    sortId = res.SortId
                    sortAsc = res.SortAsc
                    startPage = res.Page
                    criteriasExpanded = res.Expanded
                    manualColumnSelect = true
                    selectColumns(res.Columns)
                    loadSavedSearch(res.CriteriaData)
                    setFriendlyFlag20Title()
                    updateCountForSavedSearch(id)
                } else {
                    $msg.showError(res.Resultat.Message)
                }
            },
        })
    }

    function saveSearch(): void {
        var name = elem('savesearch-name').val()
        if (name.length === 0) {
            $msg.showError('Du måste ange ett namn till din sparade fråga.')
            return
        }

        var f = (function() {
            callQueue.queue(function(next) {
                $ajax.post({
                    loadingText: 'Sparar sökfråga...',
                    url: '/Search/SaveSearch',
                    data: {
                        criteriaData: JSON.stringify(serializeForm()),
                        page: currentPage,
                        sortId: sortId,
                        sortAsc: sortAsc,
                        name: name,
                        totalNo: elem('total-no').html(),
                        expanded: criteriasExpanded,
                        columns: getSelectedColumns(),
                        type: elem('savesearch-name').attr('data-type'),
                    },
                    success: function(res) {
                        if (res.Ok) {
                            $msg.show(res.Message)
                            loadSavedSearchesDropdown()
                        } else {
                            $msg.showError(res.Message)
                        }
                    },
                    complete: function() {
                        next()
                    },
                })
            })
        })()
    }

    export function elemId(name: string): string {
        return options.pagePrefix + '-' + name
    }

    export function elem(name: string): JQuery {
        return $('#' + options.pagePrefix + '-' + name)
    }

    export function elemByClass(name: string): JQuery {
        return $('.' + options.pagePrefix + '-' + name)
    }
}

export module propertyform {
    export function init($options: common.IInitOptions): void {
        common.options = $options
        common.options.countUrl = '/Search/PropertyCount'
        common.options.listUrl = '/Search/PropertyList'

        $helpers.scroll.actionWhenVisible(
            common.elem('buttonsplh'),
            (el) => {
                $('.bcfla-form-group-btn').removeClass('bcfla-form-group-btn--fixed')
                common.elem('submit-dropdown').css('margin-top', '')
            },
            (el) => {
                $('.bcfla-form-group-btn').addClass('bcfla-form-group-btn--fixed')
                common.elem('submit-dropdown').css('margin-top', -(common.elem('submit-dropdown').outerHeight() + 30))
            },
        )

        common.formFields = [
            common.elem('region'),
            common.elem('county'),
            common.elem('flags20-ids'),
            common.elem('ownerflags20-ids'),
        ]

        common.formFieldsReset = [
            common.elem('freetext'),
            common.elem('region'),
            common.elem('county'),
            common.elem('flags20-ids'),
            common.elem('ownerflags20-ids'),
            common.elem('areatotal-min'),
            common.elem('areatotal-max'),
            common.elem('areatotalind-min'),
            common.elem('areatotalind-max'),
            common.elem('areafield-min'),
            common.elem('areafield-max'),
            common.elem('areaforest-min'),
            common.elem('areaforest-max'),
            common.elem('areaforestimp-min'),
            common.elem('areaforestimp-max'),
            common.elem('areabait-min'),
            common.elem('areabait-max'),
            common.elem('virkesforrad-min'),
            common.elem('virkesforrad-max'),
            common.elem('bonitet-min'),
            common.elem('bonitet-max'),
            common.elem('felling-datefrom'),
            common.elem('felling-dateto'),
            common.elem('felling-areamin'),
            common.elem('felling-areamax'),
            common.elem('felling-company'),
            common.elem('transfer-datefrom'),
            common.elem('transfer-dateto'),
            common.elem('transfer-areamin'),
            common.elem('transfer-areamax'),
            common.elem('transfer-summin'),
            common.elem('transfer-summax'),
            common.elem('buildings-countmin'),
            common.elem('buildings-countmax'),
            common.elem('buildingssmall-countmin'),
            common.elem('buildingssmall-countmax'),
            common.elem('buildingsecon-countmin'),
            common.elem('buildingsecon-countmax'),
            common.elem('tax-summin'),
            common.elem('tax-summax'),
            common.elem('taxland-summin'),
            common.elem('taxland-summax'),
            common.elem('taxbuilding-summin'),
            common.elem('taxbuilding-summax'),
            common.elem('taxforest-summin'),
            common.elem('taxforest-summax'),
            common.elem('taxfield-summin'),
            common.elem('taxfield-summax'),
            common.elem('taxstructsmall-summin'),
            common.elem('taxstructsmall-summax'),
        ]

        common.formCheckboxes = [common.elem('stables'), common.elem('company-type'), common.elem('owner-deceased')]

        common.formCheckboxesReset = [
            common.elem('stables'),
            common.elem('freetext-cbl'),
            common.elem('company-type'),
            common.elem('owner-deceased'),
            common.elem('felling-hascompany'),
            common.elem('felling-invert'),
            common.elem('transfer-type'),
            common.elem('transfer-buytype'),
        ]

        common.formFlags = [common.elem('flags')]

        common.formSliders = [
            common.elem('areatotal-slider'),
            common.elem('areatotalind-slider'),
            common.elem('areafield-slider'),
            common.elem('areaforest-slider'),
            common.elem('areaforestimp-slider'),
            common.elem('areabait-slider'),
            common.elem('virkesforrad-slider'),
            common.elem('bonitet-slider'),
        ]

        common.formRanges = [
            [common.elem('areatotal-min'), common.elem('areatotal-max'), common.elem('areatotal-slider')],
            [common.elem('areatotalind-min'), common.elem('areatotalind-max'), common.elem('areatotalind-slider')],
            [common.elem('areafield-min'), common.elem('areafield-max'), common.elem('areafield-slider')],
            [common.elem('areaforest-min'), common.elem('areaforest-max'), common.elem('areaforest-slider')],
            [common.elem('areaforestimp-min'), common.elem('areaforestimp-max'), common.elem('areaforestimp-slider')],
            [common.elem('areabait-min'), common.elem('areabait-max'), common.elem('areabait-slider')],
            [common.elem('virkesforrad-min'), common.elem('virkesforrad-max'), common.elem('virkesforrad-slider')],
            [common.elem('bonitet-min'), common.elem('bonitet-max'), common.elem('bonitet-slider')],
        ]

        common.formCustomFields = [
            function() {
                var tb: JQuery = common.elem('freetext')
                var cbvals: string = $form.getCheckboxlistValues(common.elem('freetext-cbl')).join(',')
                var obj = {
                    CriteriaId: tb.attr('data-criteria-id'),
                    Values: tb.val() + '|' + cbvals,
                    PreviousValues: tb.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var tbareamin: JQuery = common.elem('felling-areamin')
                var tbareamax: JQuery = common.elem('felling-areamax')
                var tbdatefrom: JQuery = common.elem('felling-datefrom')
                var tbdateto: JQuery = common.elem('felling-dateto')
                var tbcompany: JQuery = common.elem('felling-company')
                var rblhascompany: JQuery = common.elem('felling-hascompany')
                var rblinvert: JQuery = common.elem('felling-invert')

                var rblhascompanyval: string = $form.getCheckboxlistValues(rblhascompany)[0]
                var rblinvertval: string = $form.getCheckboxlistValues(rblinvert)[0]

                var obj = {
                    CriteriaId: tbareamin.attr('data-criteria-id'),
                    Values:
                        tbareamin.val() +
                        '|' +
                        tbareamax.val() +
                        '|' +
                        tbdatefrom.val() +
                        '|' +
                        tbdateto.val() +
                        '|' +
                        tbcompany.val() +
                        '|' +
                        rblhascompanyval +
                        '|' +
                        rblinvertval,
                    PreviousValues: tbareamin.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var tbareamin: JQuery = common.elem('transfer-areamin')
                var tbareamax: JQuery = common.elem('transfer-areamax')
                var tbsummin: JQuery = common.elem('transfer-summin')
                var tbsummax: JQuery = common.elem('transfer-summax')
                var tbdatefrom: JQuery = common.elem('transfer-datefrom')
                var tbdateto: JQuery = common.elem('transfer-dateto')
                var cblbuytype: JQuery = common.elem('transfer-buytype')
                var cbltype: JQuery = common.elem('transfer-type')

                var cblbuytypeval: string = $form.getCheckboxlistValues(cblbuytype).join(',')
                var cbltypeval: string = $form.getCheckboxlistValues(cbltype).join(',')

                var obj = {
                    CriteriaId: tbareamin.attr('data-criteria-id'),
                    Values:
                        tbareamin.val() +
                        '|' +
                        tbareamax.val() +
                        '|' +
                        tbsummin.val() +
                        '|' +
                        tbsummax.val() +
                        '|' +
                        tbdatefrom.val() +
                        '|' +
                        tbdateto.val() +
                        '|' +
                        cblbuytypeval +
                        '|' +
                        cbltypeval,
                    PreviousValues: tbareamin.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var list: JQuery = common.elem('regionmulti-searchfor-list')
                var ids: string = list.attr('data-value')

                if (list.parents('.search-section-disabled').length > 0) return null

                var obj = {
                    CriteriaId: list.attr('data-criteria-id'),
                    Values: ids,
                    PreviousValues: list.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var list: JQuery = common.elem('countymulti-searchfor-list')
                var ids: string = list.attr('data-value')

                if (list.parents('.search-section-disabled').length > 0) return null

                var obj = {
                    CriteriaId: list.attr('data-criteria-id'),
                    Values: ids,
                    PreviousValues: list.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var list: JQuery = common.elem('district-searchfor-list')
                var ids: string[] = []
                list.find('li').each(function() {
                    ids.push($(this).attr('data-id'))
                })

                var obj = {
                    CriteriaId: list.attr('data-criteria-id'),
                    Values: ids.join(','),
                    PreviousValues: list.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
        ]

        common.formCustomFieldsLoad = [
            function(searchData) {
                var tb: JQuery = common.elem('freetext')
                var vals = $search.getCriteria(tb, searchData).Values.split('|')

                var prev = tb.val()

                tb.val(vals[0])
                $form.setCheckboxlistValues(common.elem('freetext-cbl'), vals[1])

                if (tb.val().length > 0 || tb.val() != prev) return tb
                else return null
            },
            function(searchData) {
                var ul: JQuery = common.elem('district-searchfor-list')
                var vals = $search.getCriteria(ul, searchData).Values.split('|')

                //console.log("district-searchfor load " + $search.getCriteria(ul, searchData).Values);
                //console.log(vals);
                //console.log("/Search/DistrictsListById?ids=" + vals[0]);

                common.selectedDistricts = vals[0].split(',')

                ul.html('')
                ul.attr('data-value', vals[0])

                $ajax.post({
                    loadingText: 'Hämtar distrikt...',
                    url: '/Search/DistrictsListById',
                    data: {
                        ids: vals[0],
                    },
                    dataType: 'html',
                    success: function(res) {
                        ul.html(res)
                        common.count(ul, true)
                        common.rebindDistrictEvents()
                    },
                })

                return ul
            },
            function(searchData) {
                var ul: JQuery = common.elem('regionmulti-searchfor-list')
                var cri = $search.getCriteria(ul, searchData)
                if (!cri || cri.CriteriaId == '-1') return null
                var vals = cri.Values.split('|')

                console.log('regionmulti-searchfor load ' + $search.getCriteria(ul, searchData).Values)
                //console.log(vals);
                //console.log("/Search/regionmultisListById?ids=" + vals[0]);

                common.selectedRegions = vals[0].split(',')

                ul.html('')
                ul.attr('data-value', vals[0])

                // and show the multi part of the page
                common.elem('region-section-multi').removeClass('search-section-disabled').show()
                common.elem('region-section-single').addClass('search-section-disabled').hide()

                $ajax.post({
                    loadingText: 'Hämtar län...',
                    url: '/Search/RegionsListById',
                    data: {
                        ids: vals[0],
                    },
                    dataType: 'html',
                    success: function(res) {
                        ul.html(res)
                        common.count(ul, true)
                        common.rebindRegionEvents()
                    },
                })

                return ul
            },
            function(searchData) {
                var ul: JQuery = common.elem('countymulti-searchfor-list')
                var cri = $search.getCriteria(ul, searchData)
                if (!cri || cri.CriteriaId == '-1') return null
                var vals = cri.Values.split('|')

                console.log('countymulti-searchfor load ' + $search.getCriteria(ul, searchData).Values)
                //console.log(vals);
                //console.log("/Search/CountymultisListById?ids=" + vals[0]);

                common.selectedCounties = vals[0].split(',')

                ul.html('')
                ul.attr('data-value', vals[0])

                // and show the multi part of the page
                common.elem('county-section-multi').removeClass('search-section-disabled').show()
                common.elem('county-section-single').addClass('search-section-disabled').hide()

                $ajax.post({
                    loadingText: 'Hämtar län...',
                    url: '/Search/CountiesListById',
                    data: {
                        ids: vals[0],
                    },
                    dataType: 'html',
                    success: function(res) {
                        ul.html(res)
                        common.count(ul, true)
                        common.rebindCountyEvents()
                    },
                })

                return ul
            },
            function(searchData) {
                var tbareamin: JQuery = common.elem('felling-areamin')
                var tbareamax: JQuery = common.elem('felling-areamax')
                var tbdatefrom: JQuery = common.elem('felling-datefrom')
                var tbdateto: JQuery = common.elem('felling-dateto')
                var tbcompany: JQuery = common.elem('felling-company')
                var rblhascompany: JQuery = common.elem('felling-hascompany')
                var rblinvert: JQuery = common.elem('felling-invert')

                var vals = $search.getCriteria(tbareamin, searchData).Values.split('|')

                tbareamin.val(vals[0])
                tbareamax.val(vals[1])
                tbdatefrom.val(vals[2])
                tbdateto.val(vals[3])
                tbcompany.val(vals[4])
                $form.setCheckboxlistValues(rblhascompany, vals[5])
                $form.setCheckboxlistValues(rblinvert, vals[6])

                return tbareamin
            },
            function(searchData) {
                var tbareamin: JQuery = common.elem('transfer-areamin')
                var tbareamax: JQuery = common.elem('transfer-areamax')
                var tbsummin: JQuery = common.elem('transfer-summin')
                var tbsummax: JQuery = common.elem('transfer-summax')
                var tbdatefrom: JQuery = common.elem('transfer-datefrom')
                var tbdateto: JQuery = common.elem('transfer-dateto')
                var cblbuytype: JQuery = common.elem('transfer-buytype')
                var cbltype: JQuery = common.elem('transfer-type')

                var vals = $search.getCriteria(tbareamin, searchData).Values.split('|')

                tbareamin.val(vals[0])
                tbareamax.val(vals[1])
                tbsummin.val(vals[2])
                tbsummax.val(vals[3])
                tbdatefrom.val(vals[4])
                tbdateto.val(vals[5])
                $form.setCheckboxlistValues(cblbuytype, vals[6])
                $form.setCheckboxlistValues(cbltype, vals[7])

                return tbareamin
            },
        ]

        common.formCustomFieldsReset = [
            function(changedCriterias) {
                var el: JQuery = common.elem('regionmulti-searchfor-list')
                var changed: boolean = el.find('li').length > 0
                var disabled: boolean = el.parents('.search-section-disabled').length > 0

                el.html("<li class='disabled'>-- Alla län --</li>")
                el.attr('data-value', '')

                common.selectedRegions = []

                if (changed && !disabled) {
                    changedCriterias.push(el)
                    common.fetchRegions()
                }
            },
            function(changedCriterias) {
                var el: JQuery = common.elem('countymulti-searchfor-list')
                var changed: boolean = el.find('li').length > 0
                var disabled: boolean = el.parents('.search-section-disabled').length > 0

                el.html("<li class='disabled'>-- Alla kommuner --</li>")
                el.attr('data-value', '')

                common.elem('countymulti-searchresult-list').html("<li class='disabled'>-- Välj län först --</li>")
                common.selectedCounties = []

                if (changed && !disabled) changedCriterias.push(el)
            },
            function(changedCriterias) {
                var el: JQuery = common.elem('district-searchfor-list')
                var changed: boolean = el.find('li').length > 0
                var disabled: boolean = el.parents('.search-section-disabled').length > 0

                el.html("<li class='disabled'>-- Alla distrikt --</li>")
                el.attr('data-value', '')

                common.elem('district-searchresult-list').html("<li class='disabled'>-- Välj kommun först --</li>")
                common.selectedDistricts = []

                if (changed && !disabled) changedCriterias.push(el)
            },
            function(changedCriterias) {
                setTempflagId('', '-1', ['[Inga flaggor valda]'], [])
                setTempflagId('owner', '-1', ['[Inga flaggor valda]'], [])
            },
        ]

        if (common.options.searchUtbonarbo) common.formCheckboxes.push(common.elem('utbonarbo'))
        if (common.options.searchUtbonarbo) common.formCheckboxesReset.push(common.elem('utbonarbo'))
        if (common.options.searchUtbonarbo) common.bindCountEventCheckbox(common.elem('utbonarbo'))

        common.bindCountEventCheckbox(common.elem('stables'))
        common.bindCountEventCheckbox(common.elem('company-type'))
        common.bindCountEventCheckbox(common.elem('owner-deceased'))

        if (common.options.searchFelling) {
            var debouncedCountFelling = _.debounce(function() {
                common.count(common.elem('felling-areamin'))
            }, common.debounceDelay)

            common.elem('felling-company').keyup(debouncedCountFelling)
            common.elem('felling-company').blur(debouncedCountFelling)
            common.elem('felling-company').change(debouncedCountFelling)

            common.elem('felling-areamin').keyup(debouncedCountFelling)
            common.elem('felling-areamin').blur(debouncedCountFelling)
            common.elem('felling-areamin').change(debouncedCountFelling)

            common.elem('felling-areamax').keyup(debouncedCountFelling)
            common.elem('felling-areamax').blur(debouncedCountFelling)
            common.elem('felling-areamax').change(debouncedCountFelling)

            common.elem('felling-datefrom').keyup(debouncedCountFelling)
            common.elem('felling-datefrom').blur(debouncedCountFelling)
            common.elem('felling-datefrom').change(debouncedCountFelling)

            common.elem('felling-dateto').keyup(debouncedCountFelling)
            common.elem('felling-dateto').blur(debouncedCountFelling)
            common.elem('felling-dateto').change(debouncedCountFelling)

            common.elem('felling-hascompany button').click(debouncedCountFelling)
            common.elem('felling-invert button').click(debouncedCountFelling)

            common.elem('felling-company').autocomplete({
                source: '/Search/FellingAgentAutoComplete',
                minLength: 2,
                select: function(event, ui) {
                    common.elem('felling-company').val(ui.item.value)
                    common.count(common.elem('felling-company'), true)
                },
                autoFocus: true,
                delay: 200,
                appendTo: '.' + common.options.pagePrefix + '-search-box',
            })
        }

        if (common.options.searchTransfer) {
            var debouncedCountTransfer = _.debounce(function() {
                common.count(common.elem('transfer-areamin'))
            }, common.debounceDelay)

            common.elem('transfer-areamin').keyup(debouncedCountTransfer)
            common.elem('transfer-areamin').blur(debouncedCountTransfer)
            common.elem('transfer-areamin').change(debouncedCountTransfer)

            common.elem('transfer-areamax').keyup(debouncedCountTransfer)
            common.elem('transfer-areamax').blur(debouncedCountTransfer)
            common.elem('transfer-areamax').change(debouncedCountTransfer)

            common.elem('transfer-summin').keyup(debouncedCountTransfer)
            common.elem('transfer-summin').blur(debouncedCountTransfer)
            common.elem('transfer-summin').change(debouncedCountTransfer)

            common.elem('transfer-summax').keyup(debouncedCountTransfer)
            common.elem('transfer-summax').blur(debouncedCountTransfer)
            common.elem('transfer-summax').change(debouncedCountTransfer)

            common.elem('transfer-datefrom').keyup(debouncedCountTransfer)
            common.elem('transfer-datefrom').blur(debouncedCountTransfer)
            common.elem('transfer-datefrom').change(debouncedCountTransfer)

            common.elem('transfer-dateto').keyup(debouncedCountTransfer)
            common.elem('transfer-dateto').blur(debouncedCountTransfer)
            common.elem('transfer-dateto').change(debouncedCountTransfer)

            common.elem('transfer-buytype button').click(debouncedCountTransfer)
            common.elem('transfer-type button').click(debouncedCountTransfer)

            common.elem('transfer-type button').on('click', () => {
                const cbltypeval: string = $form.getCheckboxlistValues(common.elem('transfer-type')).join(',')
                if (cbltypeval == '1') {
                    // only "helöverlåtelse" selected, then we can search in sum and buytype
                    common
                        .elem('transfer-buytype')
                        .find('button')
                        .prop('disabled', false)
                        .removeClass('bcfla-btn--disabled')

                    common.elem('transfer-summin').prop('disabled', false)
                    common.elem('transfer-summax').prop('disabled', false)
                } else {
                    // noep
                    common
                        .elem('transfer-buytype')
                        .find('button')
                        .removeClass('bcfla-checked')
                        .prop('disabled', true)
                        .addClass('bcfla-btn--disabled')

                    common.elem('transfer-summin').prop('disabled', true).val('')
                    common.elem('transfer-summax').prop('disabled', true).val('')

                    common.count(common.elem('transfer-buytype'), true)
                    common.count(common.elem('transfer-summin'), true)
                }
            })
        }

        if (common.options.searchBuildings) {
            common.initRangeWithSlider(
                common.elem('buildings-countslider'),
                common.elem('buildings-countmin'),
                common.elem('buildings-countmax'),
            )
            common.initRangeWithSlider(
                common.elem('buildingssmall-countslider'),
                common.elem('buildingssmall-countmin'),
                common.elem('buildingssmall-countmax'),
            )
            common.initRangeWithSlider(
                common.elem('buildingsecon-countslider'),
                common.elem('buildingsecon-countmin'),
                common.elem('buildingsecon-countmax'),
            )

            common.formSliders.push(common.elem('buildings-countslider'))
            common.formSliders.push(common.elem('buildingssmall-countslider'))
            common.formSliders.push(common.elem('buildingsecon-countslider'))

            common.formRanges.push([
                common.elem('buildings-countmin'),
                common.elem('buildings-countmax'),
                common.elem('buildings-countslider'),
            ])
            common.formRanges.push([
                common.elem('buildingssmall-countmin'),
                common.elem('buildingssmall-countmax'),
                common.elem('buildingssmall-countslider'),
            ])
            common.formRanges.push([
                common.elem('buildingsecon-countmin'),
                common.elem('buildingsecon-countmax'),
                common.elem('buildingsecon-countslider'),
            ])
        }

        if (common.options.searchTaxValue) {
            common.initRangeWithSlider(
                common.elem('tax-sumslider'),
                common.elem('tax-summin'),
                common.elem('tax-summax'),
            )
            common.initRangeWithSlider(
                common.elem('taxland-sumslider'),
                common.elem('taxland-summin'),
                common.elem('taxland-summax'),
            )
            common.initRangeWithSlider(
                common.elem('taxbuilding-sumslider'),
                common.elem('taxbuilding-summin'),
                common.elem('taxbuilding-summax'),
            )
            common.initRangeWithSlider(
                common.elem('taxforest-sumslider'),
                common.elem('taxforest-summin'),
                common.elem('taxforest-summax'),
            )
            common.initRangeWithSlider(
                common.elem('taxfield-sumslider'),
                common.elem('taxfield-summin'),
                common.elem('taxfield-summax'),
            )
            common.initRangeWithSlider(
                common.elem('taxstructsmall-sumslider'),
                common.elem('taxstructsmall-summin'),
                common.elem('taxstructsmall-summax'),
            )

            common.formSliders.push(common.elem('tax-sumslider'))
            common.formSliders.push(common.elem('taxland-sumslider'))
            common.formSliders.push(common.elem('taxbuilding-sumslider'))
            common.formSliders.push(common.elem('taxforest-sumslider'))
            common.formSliders.push(common.elem('taxfield-sumslider'))
            common.formSliders.push(common.elem('taxstructsmall-sumslider'))

            common.formRanges.push([common.elem('tax-summin'), common.elem('tax-summax'), common.elem('tax-sumslider')])
            common.formRanges.push([
                common.elem('taxland-summin'),
                common.elem('taxland-summax'),
                common.elem('taxland-sumslider'),
            ])
            common.formRanges.push([
                common.elem('taxbuilding-summin'),
                common.elem('taxbuilding-summax'),
                common.elem('taxbuilding-sumslider'),
            ])
            common.formRanges.push([
                common.elem('taxforest-summin'),
                common.elem('taxforest-summax'),
                common.elem('taxforest-sumslider'),
            ])
            common.formRanges.push([
                common.elem('taxfield-summin'),
                common.elem('taxfield-summax'),
                common.elem('taxfield-sumslider'),
            ])
            common.formRanges.push([
                common.elem('taxstructsmall-summin'),
                common.elem('taxstructsmall-summax'),
                common.elem('taxstructsmall-sumslider'),
            ])
        }

        common.bindCountEventDropdown(common.elem('region'))
        common.bindCountEventDropdown(common.elem('county'))

        common.initRangeWithSlider(
            common.elem('areatotal-slider'),
            common.elem('areatotal-min'),
            common.elem('areatotal-max'),
        )
        common.initRangeWithSlider(
            common.elem('areatotalind-slider'),
            common.elem('areatotalind-min'),
            common.elem('areatotalind-max'),
        )
        common.initRangeWithSlider(
            common.elem('areafield-slider'),
            common.elem('areafield-min'),
            common.elem('areafield-max'),
        )
        common.initRangeWithSlider(
            common.elem('areaforest-slider'),
            common.elem('areaforest-min'),
            common.elem('areaforest-max'),
        )
        common.initRangeWithSlider(
            common.elem('areaforestimp-slider'),
            common.elem('areaforestimp-min'),
            common.elem('areaforestimp-max'),
        )
        common.initRangeWithSlider(
            common.elem('areabait-slider'),
            common.elem('areabait-min'),
            common.elem('areabait-max'),
        )
        common.initRangeWithSlider(
            common.elem('virkesforrad-slider'),
            common.elem('virkesforrad-min'),
            common.elem('virkesforrad-max'),
        )
        common.initRangeWithSlider(
            common.elem('bonitet-slider'),
            common.elem('bonitet-min'),
            common.elem('bonitet-max'),
        )
        common.initRangeWithSlider(
            common.elem('felling-areaslider'),
            common.elem('felling-areamin'),
            common.elem('felling-areamax'),
        )
        common.initRangeWithSlider(
            common.elem('transfer-areaslider'),
            common.elem('transfer-areamin'),
            common.elem('transfer-areamax'),
        )

        // fritext
        {
            var debouncedCountFritext = _.debounce(function() {
                common.count(common.elem('freetext'))
            }, common.debounceDelay)

            $('#' + common.elemId('freetext-cbl') + ' > button').click(function() {
                debouncedCountFritext()
            })

            common.elem('freetext').on('blur', function() {
                debouncedCountFritext()
            })

            $helpers.onEnter(common.elem('freetext'), function(tb: JQuery) {
                tb.trigger('blur')
            })

            common.elem('freetext').autocomplete({
                source: function(request, response) {
                    var cbvals: string = $form.getCheckboxlistValues(common.elem('freetext-cbl')).join(',')
                    const txt: string = common.elem('freetext').val()

                    if (cbvals !== '0' || !(txt.length > 0)) {
                        response(null)
                        return
                    }

                    let regions = ''

                    if (common.elem('region-section-multi').is(':visible')) {
                        regions = common.elem('regionmulti-searchfor-list').attr('data-value')
                    } else {
                        regions = common.elem('region').val()
                    }

                    $ajax.post({
                        loadingText: 'Söker...',
                        url: '/Search/PropertyNameAutoComplete',
                        dataType: 'json',
                        data: {
                            regions: regions,
                            term: request.term,
                            countysearch: 'false',
                        },
                        success: function(res) {
                            response(res)
                        },
                    })
                },
                minLength: 2,
                disabled: false,
                select: function(_event, ui) {
                    common.elem('freetext').val(ui.item.value)
                    debouncedCountFritext()
                },
                autoFocus: true,
                delay: 250,
                appendTo: '.' + common.options.pagePrefix + '-freetext',
            })
        }

        common.elem('flags20-modal').click(function() {
            var flagids: string = common.elem('flags20-ids').val()
            var doclear: boolean = flagids.length === 0 || flagids === '-1'
            $modal.load('/Flag/SearchPropertyTempflagModal', { clear: doclear, prefix: '' }, false, true, false)
        })

        common.elem('ownerflags20-modal').click(function() {
            var flagids: string = common.elem('ownerflags20-ids').val()
            var doclear: boolean = flagids.length === 0 || flagids === '-1'
            $modal.load(
                '/Flag/SearchTempflagModal',
                { clear: doclear, propertysearch: true, prefix: 'owner' },
                false,
                true,
                false,
            )
        })

        common.elem('flags20-clear').click(function() {
            setTempflagId('', '-1', ['[Inga flaggor valda]'], [])
        })

        common.elem('ownerflags20-clear').click(function() {
            setTempflagId('owner', '-1', ['[Inga flaggor valda]'], [])
        })

        // export buttons
        common.elemByClass('submit-dropdown-button').click(function() {
            var btn: JQuery = $(this)
            showGetFileModal(btn.attr('data-id'))
        })

        common.elem('transfer-to-owner').click(function() {
            $ajax.post({
                loadingText: 'Flyttar över sökresultat...',
                url: '/Owner/SavePropertySearchToTempFlag',
                data: {
                    criteriaData: JSON.stringify(common.serializeForm()),
                    totalNo: common.elem('total-no').html(),
                },
                success: function(res) {
                    if (res.Ok) {
                        location.href = '/Search/OwnerForm'
                    } else {
                        $msg.showError(res.Message)
                    }
                },
            })
        })

        common.init()
        common.fetchRegions(function() {
            // load latest search after regions have been fetched the first time
            // otherwise it could go:
            //   1 start to fetch all regions
            //   2 load latest search
            //   3 set regions from latest search
            //   4 all regions finishes loading and overwrites latest search regions
            if ($options.fetchSearchId && $options.fetchSearchId > 0) common.fetchSavedSearch($options.fetchSearchId)
            else common.loadLatestSearch('/Search/FetchLatestForProperty')
        })

        $blogpostpopup.load(2)
        $help.tooltips.initializeTooltips($('.' + $options.pageName))
    }

    export function setTempflagId(prefix: string, id: string, names: string[], ids: string[]): void {
        common.elem(prefix + 'flags20-id').attr('data-previous-value', '-666') // to make sure the value is seen as changed and the count is reevalued
        common.elem(prefix + 'flags20-id').val(id)
        common.elem(prefix + 'flags20-ids').val(ids.join(','))
        common.elem(prefix + 'flags20-names').html(names.join('<br/>'))
        common.count(common.elem(prefix + 'flags20-ids'))
    }

    function showGetFileModal(templateId: string): void {
        $modal.load(
            '/Export/PropertyGetFileModal',
            { templateId: templateId, totalNo: common.elem('total-no').html() },
            false,
            false,
            false,
        )
    }

    export function getFile(templateId: string): void {
        var f = (function() {
            $modal.show('Sparar sökresultat till fil...')

            $ajax.post({
                loadingText: 'Sparar sökresultat till fil...',
                url: '/Export/PropertyFile',
                data: {
                    criteriaData: JSON.stringify(common.serializeForm()),
                    totalNo: common.elem('total-no').html(),
                    templateId: templateId,
                    sortId: common.sortId,
                    sortAsc: common.sortAsc,
                },
                success: function(res) {
                    if (res.Ok) {
                        if (res.OverLimit) {
                            $modal.show(
                                '<h4>Export startad</h4><p>Ditt data håller på att exporteras. Pga datamängden behöver detta först godkännas av en administratör. När det är gjort, kommer du få ett mail med en länk till din fil.</p><p>Har du frågor kring detta - kontakta supporten på <a href="tel:0707254618">070-725 46 18</a> eller maila oss på <a href="mailto:camo@biscom.se">camo@biscom.se</a>.</p><p>Mvh<br/>LantbruksFaktaDigital / Biscom<br/><a href="http://www.lantbruksfaktadigital.se">www.lantbruksfaktadigital.se</a><br/>Carl-Johan Mossberg<br/><a href="tel:0707254618">070-725 46 18</a><br/><a href="mailto:camo@biscom.se">camo@biscom.se</a></p>',
                                true,
                                false,
                            )
                        } else {
                            $modal.show(
                                '<h4>Export startad</h4><p>Ditt data håller på att exporteras. När det är klart, kommer du få ett mail med en länk till din fil.</p><p>Har du frågor kring detta - kontakta supporten på <a href="tel:0707254618">070-725 46 18</a> eller maila oss på <a href="mailto:camo@biscom.se">camo@biscom.se</a>.</p><p>Mvh<br/>LantbruksFaktaDigital / Biscom<br/><a href="http://www.lantbruksfaktadigital.se">www.lantbruksfaktadigital.se</a><br/>Carl-Johan Mossberg<br/><a href="tel:0707254618">070-725 46 18</a><br/><a href="mailto:camo@biscom.se">camo@biscom.se</a></p>',
                                true,
                                false,
                            )
                        }
                    } else {
                        $modal.hide()
                        $msg.showError(res.Message)
                    }
                },
            })
        })()
    }
}

export module propertylist {
    var options: any

    export function init($options: any): void {
        options = $.extend(true, {}, $options)

        $('.' + options.pageName + ' .bcfla-th-sortable').click(function() {
            common.setSort(parseInt($(this).attr('data-sortid')), $(this).attr('data-sortasc'))
            common.getList(1)
        })

        var statselem = $('#bcfla-pspf-statistics')

        if (statselem.length > 0 && (statselem.html().length === 0 || options.pageNo === 1)) {
            $ajax.post({
                loadingText: 'Laddar statistik...',
                url: '/Search/PropertyStats',
                data: {
                    criteriaData: JSON.stringify(common.serializeForm()),
                    sortId: common.sortId,
                    sortAsc: common.sortAsc,
                    totalNo: common.elem('total-no').html(),
                    columns: common.getSelectedColumns(),
                },
                dataType: 'html',
                success: function(res) {
                    statselem.html(res)
                },
            })
        }

        $('.' + options.pagePrefix + '-owners-expando').click(function() {
            var id = $(this).attr('data-id')
            var row1 = $('.' + options.pagePrefix + '-list-tr-p' + id)
            var row2 = $('.' + options.pagePrefix + '-list-tr2-p' + id)

            row2.toggleClass('bcfla-hidden')

            setTimeout(function() {
                if (!row2.hasClass('bcfla-hidden')) {
                    row1.find('.' + options.pagePrefix + '-owners-expando-icon').html(
                        '<span class="fas fa-chevron-down"></span>',
                    )

                    $ajax.post({
                        loadingText: 'Hämtar ägare...',
                        url: '/Owner/ListOwnersForProperty',
                        data: {
                            propertyId: id,
                            propertyIds: options.propertyIds,
                        },
                        dataType: 'html',
                        success: function(res) {
                            row2.find('.' + options.pagePrefix + '-list-tr2-contenttd').html(res)
                        },
                    })
                } else {
                    row1.find('.' + options.pagePrefix + '-owners-expando-icon').html(
                        '<span class="fas fa-chevron-right"></span>',
                    )
                }
            }, 50)
        })

        if (options.expandSubRow) {
            $('.' + options.pagePrefix + '-owners-expando-icon').each(function() {
                $(this).trigger('click')
            })
        }

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-addordelete button').click(function() {
            var addTo = $(this).attr('data-value') == 'true'
            if (addTo) {
                $('.' + options.pageName + ' .' + options.pagePrefix + '-flagall-addordeletelabel-addto').removeClass(
                    'bcfla-hidden',
                )
                $('.' + options.pageName + ' .' + options.pagePrefix + '-flagall-addordeletelabel-deletefrom').addClass(
                    'bcfla-hidden',
                )
            } else {
                $('.' + options.pageName + ' .' + options.pagePrefix + '-flagall-addordeletelabel-addto').addClass(
                    'bcfla-hidden',
                )
                $(
                    '.' + options.pageName + ' .' + options.pagePrefix + '-flagall-addordeletelabel-deletefrom',
                ).removeClass('bcfla-hidden')
            }
        })

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-flags span').click(function() {
            $(this).toggleClass('bcfla-label-unchecked')
            setTimeout(function() {
                checkFlagAllSelected()
            }, 200)
        })

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-submit').click(function() {
            submitFlagAll()
        })

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagallprop-addordelete button').click(function() {
            var addTo = $(this).attr('data-value') == 'true'
            if (addTo) {
                $(
                    '.' + options.pageName + ' .' + options.pagePrefix + '-flagallprop-addordeletelabel-addto',
                ).removeClass('bcfla-hidden')
                $(
                    '.' + options.pageName + ' .' + options.pagePrefix + '-flagallprop-addordeletelabel-deletefrom',
                ).addClass('bcfla-hidden')
            } else {
                $('.' + options.pageName + ' .' + options.pagePrefix + '-flagallprop-addordeletelabel-addto').addClass(
                    'bcfla-hidden',
                )
                $(
                    '.' + options.pageName + ' .' + options.pagePrefix + '-flagallprop-addordeletelabel-deletefrom',
                ).removeClass('bcfla-hidden')
            }
        })

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagallprop-flags span').click(function() {
            $(this).toggleClass('bcfla-label-unchecked')
            setTimeout(function() {
                checkFlagAllPropertySelected()
            }, 200)
        })

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagallprop-submit').click(function() {
            submitFlagAllProperty()
        })

        $flag.bindToggleFlagEvents($('.' + options.pagePrefix + '-td-flags'))
        $help.tooltips.initializeTooltips($('.' + $options.pageName))

        if (!options.exportAccount) {
            $(
                '.' +
                options.pagePrefix +
                '-td-name a, .' +
                options.pagePrefix +
                '-td-owner a, .' +
                options.pagePrefix +
                '-td-notes a',
            ).click(function(e) {
                var url = $(this).attr('data-link')
                $modal.load(url, { edit: 'notes' }, false, true, true)
                e.preventDefault()
            })
        }

        $helpers.partialPageInit($('.' + options.pageName))
    }

    function checkFlagAllSelected() {
        var flagged = 0
        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-flags span').each(function() {
            if (!$(this).hasClass('bcfla-label-unchecked')) flagged++
        })
        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-submit').prop('disabled', flagged === 0)
    }

    function submitFlagAll() {
        var flags: string[] = []
        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-flags span').each(function() {
            if (!$(this).hasClass('bcfla-label-unchecked')) flags.push($(this).attr('data-flagid'))
        })

        var add: string = $(
            '.' + options.pageName + ' #' + options.pagePrefix + '-flagall-addordelete button.bcfla-checked',
        ).attr('data-value')

        var currentPage: string = $(
            '.' + options.pageName + ' #' + options.pagePrefix + '-flagall-currentpage button.bcfla-checked',
        ).attr('data-value')
        var households: string = $(
            '.' + options.pageName + ' #' + options.pagePrefix + '-flagall-households button.bcfla-checked',
        ).attr('data-value')

        $ajax.post({
            loadingText: 'Sparar flaggning...',
            url: '/Owner/FlagMultiByProperty',
            data: {
                add: add,
                currentPage: currentPage,
                households: households,
                page: common.currentPage,
                rowsperpage: common.displayedRowsPerPage,
                sortId: common.sortId,
                sortAsc: common.sortAsc,
                flags: flags.join(','),
                criteriaData: JSON.stringify(common.serializeForm()),
            },
            success: function(res) {
                common.getList(common.currentPage)
            },
        })
    }

    function checkFlagAllPropertySelected() {
        var flagged = 0
        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagallprop-flags span').each(function() {
            if (!$(this).hasClass('bcfla-label-unchecked')) flagged++
        })
        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagallprop-submit').prop('disabled', flagged === 0)
    }

    function submitFlagAllProperty() {
        var flags: string[] = []
        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagallprop-flags span').each(function() {
            if (!$(this).hasClass('bcfla-label-unchecked')) flags.push($(this).attr('data-flagid'))
        })

        var add: string = $(
            '.' + options.pageName + ' #' + options.pagePrefix + '-flagallprop-addordelete button.bcfla-checked',
        ).attr('data-value')

        var currentPage: string = $(
            '.' + options.pageName + ' #' + options.pagePrefix + '-flagallprop-currentpage button.bcfla-checked',
        ).attr('data-value')

        $ajax.post({
            loadingText: 'Sparar flaggning...',
            url: '/Property/FlagMulti',
            data: {
                add: add,
                currentPage: currentPage,
                page: common.currentPage,
                rowsperpage: common.displayedRowsPerPage,
                sortId: common.sortId,
                sortAsc: common.sortAsc,
                flags: flags.join(','),
                criteriaData: JSON.stringify(common.serializeForm()),
            },
            success: function(res) {
                common.getList(common.currentPage)
            },
        })
    }
}

export module ownerform {
    var callQueue: JQuery = $({})

    export function init($options: common.IInitOptions): void {
        common.options = $options
        var controller = $('body').attr('data-use-search-v2') == 'true' ? '/SearchV2' : '/Search'
        common.options.countUrl = controller + '/OwnerCount'
        common.options.listUrl = controller + '/OwnerList'
        $help.tooltips.initializeTooltips($('.' + $options.pageName))

        $helpers.scroll.actionWhenVisible(
            common.elem('buttonsplh'),
            (el) => {
                $('.bcfla-form-group-btn').removeClass('bcfla-form-group-btn--fixed')
                common.elem('submit-dropdown').css('margin-top', '')
            },
            (el) => {
                $('.bcfla-form-group-btn').addClass('bcfla-form-group-btn--fixed')
                common.elem('submit-dropdown').css('margin-top', -(common.elem('submit-dropdown').outerHeight() + 30))
            },
        )

        common.formFields = [
            common.elem('region'),
            common.elem('county'),
            common.elem('city'),
            common.elem('zipno'),
            common.elem('trade'),
            common.elem('flags20-ids'),
        ]

        common.formFieldsReset = [
            common.elem('freetextname'),
            common.elem('region'),
            common.elem('county'),
            common.elem('city'),
            common.elem('zipno'),
            common.elem('trade'),
            common.elem('flags20-ids'),
            common.elem('regyear-min'),
            common.elem('regyear-max'),
            common.elem('birthyear-min'),
            common.elem('birthyear-max'),
            common.elem('areatotal-min'),
            common.elem('areatotal-max'),
            common.elem('areatotalind-min'),
            common.elem('areatotalind-max'),
            common.elem('areafield-min'),
            common.elem('areafield-max'),
            common.elem('areaforest-min'),
            common.elem('areaforest-max'),
            common.elem('areaprop-min'),
            common.elem('areaprop-max'),
            common.elem('owpaprop-min'),
            common.elem('owpaprop-max'),
            common.elem('felling-datefrom'),
            common.elem('felling-dateto'),
            common.elem('felling-areamin'),
            common.elem('felling-areamax'),
            common.elem('felling-company'),
            common.elem('ownercreated-datefrom'),
            common.elem('ownercreated-dateto'),
            common.elem('transfer-datefrom'),
            common.elem('transfer-dateto'),
            common.elem('transfer-areamin'),
            common.elem('transfer-areamax'),
            common.elem('transfer-summin'),
            common.elem('transfer-summax'),
            common.elem('change-date'),
            common.elem('buildings-countmin'),
            common.elem('buildings-countmax'),
            common.elem('buildingssmall-countmin'),
            common.elem('buildingssmall-countmax'),
            common.elem('buildingsecon-countmin'),
            common.elem('buildingsecon-countmax'),
            common.elem('virkesforrad-countmin'),
            common.elem('virkesforrad-countmax'),
            common.elem('bonitet-countmin'),
            common.elem('bonitet-countmax'),
            common.elem('tax-summin'),
            common.elem('tax-summax'),
            common.elem('taxland-summin'),
            common.elem('taxland-summax'),
            common.elem('taxbuilding-summin'),
            common.elem('taxbuilding-summax'),
            common.elem('taxstructsmall-summin'),
            common.elem('taxstructsmall-summax'),
            common.elem('taxforest-summin'),
            common.elem('taxforest-summax'),
            common.elem('vehicles-countmin'),
            common.elem('vehicles-countmax'),
            common.elem('vehicletractors-countmin'),
            common.elem('vehicletractors-countmax'),
            common.elem('vehicleskotares-countmin'),
            common.elem('vehicleskotares-countmax'),
            common.elem('vehicles-yearmin'),
            common.elem('vehicles-yearmax'),
            common.elem('vehicles-purchaseyearmin'),
            common.elem('vehicles-purchaseyearmax'),
            common.elem('vehicles-weightmin'),
            common.elem('vehicles-weightmax'),
            common.elem('vehicles-horsepowermin'),
            common.elem('vehicles-horsepowermax'),
            common.elem('vehiclemodel'),
            common.elem('vehicleregno'),
            common.elem('vehicleownerscount'),
            common.elem('note-freetext'),
            common.elem('note-datefrom'),
            common.elem('note-dateto'),
            common.elem('note-returndatefrom'),
            common.elem('note-returndateto'),
        ]

        common.formCheckboxes = [common.elem('stables')]

        common.formCheckboxesReset = [
            common.elem('stables'),
            common.elem('freetextname-cbl'),
            common.elem('felling-hascompany'),
            common.elem('felling-invert'),
            common.elem('transfer-buytype'),
            common.elem('transfer-type'),
            common.elem('ownercreated-type'),
            common.elem('change'),
            common.elem('vehicletype'),
            common.elem('vehiclebrand'),
            common.elem('vehiclestatus'),
            common.elem('note-types'),
        ]

        common.formFlags = []

        common.formSliders = [
            common.elem('regyear-slider'),
            common.elem('birthyear-slider'),
            common.elem('areatotal-slider'),
            common.elem('areatotalind-slider'),
            common.elem('areafield-slider'),
            common.elem('areaforest-slider'),
            common.elem('virkesforrad-countslider'),
            common.elem('bonitet-countslider'),
        ]

        common.formRanges = [
            [common.elem('regyear-min'), common.elem('regyear-max'), common.elem('regyear-slider')],
            [common.elem('birthyear-min'), common.elem('birthyear-max'), common.elem('birthyear-slider')],
            [common.elem('areatotal-min'), common.elem('areatotal-max'), common.elem('areatotal-slider')],
            [common.elem('areatotalind-min'), common.elem('areatotalind-max'), common.elem('areatotalind-slider')],
            [common.elem('areafield-min'), common.elem('areafield-max'), common.elem('areafield-slider')],
            [common.elem('areaforest-min'), common.elem('areaforest-max'), common.elem('areaforest-slider')],
            [
                common.elem('virkesforrad-countmin'),
                common.elem('virkesforrad-countmax'),
                common.elem('virkesforrad-countslider'),
            ],
            [common.elem('bonitet-countmin'), common.elem('bonitet-countmax'), common.elem('bonitet-countslider')],
        ]

        if (common.options.searchPropertyOwnedPart) {
            common.formSliders.push(common.elem('areaprop-slider'))
            common.formSliders.push(common.elem('owpaprop-slider'))
            common.formRanges.push([
                common.elem('areaprop-min'),
                common.elem('areaprop-max'),
                common.elem('areaprop-slider'),
            ])
            common.formRanges.push([
                common.elem('owpaprop-min'),
                common.elem('owpaprop-max'),
                common.elem('owpaprop-slider'),
            ])
        }

        common.formCustomFields = [
            function() {
                var tb: JQuery = common.elem('freetextname')
                var cbvals: string = $form.getCheckboxlistValues(common.elem('freetextname-cbl')).join(',')
                var obj = {
                    CriteriaId: tb.attr('data-criteria-id'),
                    Values: tb.val() + '|' + cbvals,
                    PreviousValues: tb.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var tb: JQuery = common.elem('note-freetext')
                var datefrom: JQuery = common.elem('note-datefrom')
                var dateto: JQuery = common.elem('note-dateto')
                var returndatefrom: JQuery = common.elem('note-returndatefrom')
                var returndateto: JQuery = common.elem('note-returndateto')
                var types: string = $form.getCheckboxlistValues(common.elem('note-types')).join(',')
                var obj = {
                    CriteriaId: tb.attr('data-criteria-id'),
                    Values:
                        tb.val() +
                        '|' +
                        datefrom.val() +
                        '|' +
                        dateto.val() +
                        '|' +
                        returndatefrom.val() +
                        '|' +
                        returndateto.val() +
                        '|' +
                        types,
                    PreviousValues: tb.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var tbareamin: JQuery = common.elem('felling-areamin')
                var tbareamax: JQuery = common.elem('felling-areamax')
                var tbdatefrom: JQuery = common.elem('felling-datefrom')
                var tbdateto: JQuery = common.elem('felling-dateto')
                var tbcompany: JQuery = common.elem('felling-company')
                var rblhascompany: JQuery = common.elem('felling-hascompany')
                var rblinvert: JQuery = common.elem('felling-invert')

                var rblhascompanyval: string = $form.getCheckboxlistValues(rblhascompany)[0]
                var rblinvertval: string = $form.getCheckboxlistValues(rblinvert)[0]

                var obj = {
                    CriteriaId: tbareamin.attr('data-criteria-id'),
                    Values:
                        tbareamin.val() +
                        '|' +
                        tbareamax.val() +
                        '|' +
                        tbdatefrom.val() +
                        '|' +
                        tbdateto.val() +
                        '|' +
                        tbcompany.val() +
                        '|' +
                        rblhascompanyval +
                        '|' +
                        rblinvertval,
                    PreviousValues: tbareamin.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var tbyearmin: JQuery = common.elem('vehicles-yearmin')
                var tbyearmax: JQuery = common.elem('vehicles-yearmax')
                var tbpurchaseyearmin: JQuery = common.elem('vehicles-purchaseyearmin')
                var tbpurchaseyearmax: JQuery = common.elem('vehicles-purchaseyearmax')
                var tbweightmin: JQuery = common.elem('vehicles-weightmin')
                var tbweightmax: JQuery = common.elem('vehicles-weightmax')
                var tbhorsepowermin: JQuery = common.elem('vehicles-horsepowermin')
                var tbhorsepowermax: JQuery = common.elem('vehicles-horsepowermax')
                var tbmodel: JQuery = common.elem('vehiclemodel')
                var tbregno: JQuery = common.elem('vehicleregno')
                var tbownerscount: JQuery = common.elem('vehicleownerscount')
                var cbltype: JQuery = common.elem('vehicletype')
                var cblbrand: JQuery = common.elem('vehiclebrand')
                var cblstatus: JQuery = common.elem('vehiclestatus')

                var cbltypeval: string = $form.getCheckboxlistValues(cbltype).join(',')
                var cblbrandval: string = $form.getCheckboxlistValues(cblbrand).join(',')
                var cblstatusval: string = $form.getCheckboxlistValues(cblstatus).join(',')

                var obj = {
                    CriteriaId: tbyearmin.attr('data-criteria-id'),
                    Values:
                        tbyearmin.val() +
                        '|' +
                        tbyearmax.val() +
                        '|' +
                        tbpurchaseyearmin.val() +
                        '|' +
                        tbpurchaseyearmax.val() +
                        '|' +
                        tbweightmin.val() +
                        '|' +
                        tbweightmax.val() +
                        '|' +
                        tbhorsepowermin.val() +
                        '|' +
                        tbhorsepowermax.val() +
                        '|' +
                        tbmodel.val() +
                        '|' +
                        cbltypeval +
                        '|' +
                        cblbrandval +
                        '|' +
                        cblstatusval +
                        '|' +
                        tbregno.val() +
                        '|' +
                        tbownerscount.val(),
                    PreviousValues: tbyearmin.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var tbareamin: JQuery = common.elem('transfer-areamin')
                var tbareamax: JQuery = common.elem('transfer-areamax')
                var tbsummin: JQuery = common.elem('transfer-summin')
                var tbsummax: JQuery = common.elem('transfer-summax')
                var tbdatefrom: JQuery = common.elem('transfer-datefrom')
                var tbdateto: JQuery = common.elem('transfer-dateto')
                var cblbuytype: JQuery = common.elem('transfer-buytype')
                var cbltype: JQuery = common.elem('transfer-type')

                var cblbuytypeval: string = $form.getCheckboxlistValues(cblbuytype).join(',')
                var cbltypeval: string = $form.getCheckboxlistValues(cbltype).join(',')

                var obj = {
                    CriteriaId: tbareamin.attr('data-criteria-id'),
                    Values:
                        tbareamin.val() +
                        '|' +
                        tbareamax.val() +
                        '|' +
                        tbsummin.val() +
                        '|' +
                        tbsummax.val() +
                        '|' +
                        tbdatefrom.val() +
                        '|' +
                        tbdateto.val() +
                        '|' +
                        cblbuytypeval +
                        '|' +
                        cbltypeval,
                    PreviousValues: tbareamin.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var list: JQuery = common.elem('trade-searchfor-list')
                var ids: string[] = []
                list.find('li').each(function() {
                    ids.push($(this).attr('data-id'))
                })

                var obj = {
                    CriteriaId: list.attr('data-criteria-id'),
                    Values: ids.join(','),
                    PreviousValues: list.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var list: JQuery = common.elem('regionmulti-searchfor-list')
                var ids: string = list.attr('data-value')

                if (list.parents('.search-section-disabled').length > 0) return null

                var obj = {
                    CriteriaId: list.attr('data-criteria-id'),
                    Values: ids,
                    PreviousValues: list.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var list: JQuery = common.elem('countymulti-searchfor-list')
                var ids: string = list.attr('data-value')

                if (list.parents('.search-section-disabled').length > 0) return null

                var obj = {
                    CriteriaId: list.attr('data-criteria-id'),
                    Values: ids,
                    PreviousValues: list.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var list: JQuery = common.elem('district-searchfor-list')
                var ids: string = list.attr('data-value')

                var obj = {
                    CriteriaId: list.attr('data-criteria-id'),
                    Values: ids,
                    PreviousValues: list.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var btns: JQuery = common.elem('change')
                var date: JQuery = common.elem('change-date')

                var types: string[] = []
                btns.find('.bcfla-checked').each(function() {
                    types.push($(this).attr('data-value'))
                })

                var obj = {
                    CriteriaId: btns.attr('data-criteria-id'),
                    Values: types.join(',') + '|' + date.val(),
                    PreviousValues: btns.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
            function() {
                var datefrom: JQuery = common.elem('ownercreated-datefrom')
                var dateto: JQuery = common.elem('ownercreated-dateto')
                var type: JQuery = common.elem('ownercreated-type')

                var cbltypes: string[] = $form.getCheckboxlistValues(type)

                var obj = {
                    CriteriaId: datefrom.attr('data-criteria-id'),
                    Values: datefrom.val() + '|' + dateto.val() + '|' + cbltypes,
                    PreviousValues: datefrom.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
        ]

        common.formCustomFieldsLoad = [
            function(searchData) {
                var tb: JQuery = common.elem('freetextname')
                var vals = $search.getCriteria(tb, searchData).Values.split('|')

                var prev = tb.val()

                tb.val(vals[0])
                $form.setCheckboxlistValues(common.elem('freetextname-cbl'), vals[1])

                if (tb.val().length > 0 || tb.val() != prev) return tb
                else return null
            },
            function(searchData) {
                var tb: JQuery = common.elem('note-freetext')
                var datefrom: JQuery = common.elem('note-datefrom')
                var dateto: JQuery = common.elem('note-dateto')
                var returndatefrom: JQuery = common.elem('note-returndatefrom')
                var returndateto: JQuery = common.elem('note-returndateto')
                var types: JQuery = common.elem('note-types')

                var vals = $search.getCriteria(tb, searchData).Values.split('|')

                tb.val(vals[0])
                datefrom.val(vals[1])
                dateto.val(vals[2])
                returndatefrom.val(vals[3])
                returndateto.val(vals[4])
                $form.setCheckboxlistValues(types, vals[5])

                return tb
            },
            function(searchData) {
                var tbareamin: JQuery = common.elem('felling-areamin')
                var tbareamax: JQuery = common.elem('felling-areamax')
                var tbdatefrom: JQuery = common.elem('felling-datefrom')
                var tbdateto: JQuery = common.elem('felling-dateto')
                var tbcompany: JQuery = common.elem('felling-company')
                var rblhascompany: JQuery = common.elem('felling-hascompany')
                var rblinvert: JQuery = common.elem('felling-invert')

                var vals = $search.getCriteria(tbareamin, searchData).Values.split('|')

                tbareamin.val(vals[0])
                tbareamax.val(vals[1])
                tbdatefrom.val(vals[2])
                tbdateto.val(vals[3])
                tbcompany.val(vals[4])
                $form.setCheckboxlistValues(rblhascompany, vals[5])
                $form.setCheckboxlistValues(rblinvert, vals[6])

                return tbareamin
            },
            function(searchData) {
                var datefrom: JQuery = common.elem('ownercreated-datefrom')
                var dateto: JQuery = common.elem('ownercreated-dateto')
                var type: JQuery = common.elem('ownercreated-type')

                var vals = $search.getCriteria(datefrom, searchData).Values.split('|')

                datefrom.val(vals[0])
                dateto.val(vals[1])
                $form.setCheckboxlistValues(type, vals[2])

                return datefrom
            },
            function(searchData) {
                var tbyearmin: JQuery = common.elem('vehicles-yearmin')
                var tbyearmax: JQuery = common.elem('vehicles-yearmax')
                var tbpurchaseyearmin: JQuery = common.elem('vehicles-purchaseyearmin')
                var tbpurchaseyearmax: JQuery = common.elem('vehicles-purchaseyearmax')
                var tbweightmin: JQuery = common.elem('vehicles-weightmin')
                var tbweightmax: JQuery = common.elem('vehicles-weightmax')
                var tbhorsepowermin: JQuery = common.elem('vehicles-horsepowermin')
                var tbhorsepowermax: JQuery = common.elem('vehicles-horsepowermax')
                var tbmodel: JQuery = common.elem('vehiclemodel')
                var tbregno: JQuery = common.elem('vehicleregno')
                var tbownerscount: JQuery = common.elem('vehicleownerscount')
                var cbltype: JQuery = common.elem('vehicletype')
                var cblbrand: JQuery = common.elem('vehiclebrand')
                var cblstatus: JQuery = common.elem('vehiclestatus')

                if (!common.options.searchVehicles) return tbyearmin

                var vals = $search.getCriteria(tbyearmin, searchData).Values.split('|')

                tbyearmin.val(vals[0])
                tbyearmax.val(vals[1])
                tbpurchaseyearmin.val(vals[2])
                tbpurchaseyearmax.val(vals[3])
                tbweightmin.val(vals[4])
                tbweightmax.val(vals[5])
                tbhorsepowermin.val(vals[6])
                tbhorsepowermax.val(vals[7])
                tbmodel.val(vals[8])
                tbregno.val(vals.length > 12 ? vals[12] : '') // for backwards compability
                tbownerscount.val(vals.length > 13 ? vals[13] : '') // for backwards compability
                $form.setCheckboxlistValues(cbltype, vals[9])
                $form.setCheckboxlistValues(cblbrand, vals[10])
                $form.setCheckboxlistValues(cblstatus, vals[11])

                common.elem('vehicles-yearslider').slider('values', [parseInt(vals[0]), parseInt(vals[1])])
                common.elem('vehicles-weightslider').slider('values', [parseInt(vals[4]), parseInt(vals[5])])
                common.elem('vehicles-horsepowerslider').slider('values', [parseInt(vals[6]), parseInt(vals[7])])

                return tbyearmin
            },
            function(searchData) {
                var tbareamin: JQuery = common.elem('transfer-areamin')
                var tbareamax: JQuery = common.elem('transfer-areamax')
                var tbsummin: JQuery = common.elem('transfer-summin')
                var tbsummax: JQuery = common.elem('transfer-summax')
                var tbdatefrom: JQuery = common.elem('transfer-datefrom')
                var tbdateto: JQuery = common.elem('transfer-dateto')
                var cblbuytype: JQuery = common.elem('transfer-buytype')
                var cbltype: JQuery = common.elem('transfer-type')

                var vals = $search.getCriteria(tbareamin, searchData).Values.split('|')

                tbareamin.val(vals[0])
                tbareamax.val(vals[1])
                tbsummin.val(vals[2])
                tbsummax.val(vals[3])
                tbdatefrom.val(vals[4])
                tbdateto.val(vals[5])
                $form.setCheckboxlistValues(cblbuytype, vals[6])
                $form.setCheckboxlistValues(cbltype, vals[7])

                return tbareamin
            },
            function(searchData) {
                var ul: JQuery = common.elem('trade-searchfor-list')
                var vals = $search.getCriteria(ul, searchData).Values.split('|')

                ul.html('')

                $ajax.post({
                    loadingText: 'Hämtar SNI...',
                    url: '/Search/TradesListById',
                    data: {
                        ids: vals[0],
                    },
                    dataType: 'html',
                    success: function(res) {
                        ul.html(res)
                        common.count(ul, true)
                        rebindTradeEvents()
                    },
                })

                return ul
            },
            function(searchData) {
                var ul: JQuery = common.elem('district-searchfor-list')
                var vals = $search.getCriteria(ul, searchData).Values.split('|')

                //console.log("district-searchfor load " + $search.getCriteria(ul, searchData).Values);
                //console.log(vals);
                //console.log("/Search/DistrictsListById?ids=" + vals[0]);

                common.selectedDistricts = vals[0].split(',')

                ul.html('')
                ul.attr('data-value', vals[0])

                $ajax.post({
                    loadingText: 'Hämtar distrikt...',
                    url: '/Search/DistrictsListById',
                    data: {
                        ids: vals[0],
                    },
                    dataType: 'html',
                    success: function(res) {
                        ul.html(res)
                        common.count(ul, true)
                        common.rebindDistrictEvents()
                    },
                })

                return ul
            },
            function(searchData) {
                var ul: JQuery = common.elem('regionmulti-searchfor-list')
                var cri = $search.getCriteria(ul, searchData)
                if (!cri || cri.CriteriaId == '-1') return null
                var vals = cri.Values.split('|')

                console.log('regionmulti-searchfor load ' + $search.getCriteria(ul, searchData).Values)
                console.log(cri)
                console.log(vals)
                console.log(vals[0].split(','))
                //console.log("/Search/regionmultisListById?ids=" + vals[0]);

                common.selectedRegions = vals[0].split(',')

                ul.html('')
                ul.attr('data-value', vals[0])

                // and show the multi part of the page
                common.elem('region-section-multi').removeClass('search-section-disabled').show()
                common.elem('region-section-single').addClass('search-section-disabled').hide()

                $ajax.post({
                    loadingText: 'Hämtar län...',
                    url: '/Search/RegionsListById',
                    data: {
                        ids: vals[0],
                    },
                    dataType: 'html',
                    success: function(res) {
                        ul.html(res)
                        common.count(ul, true)
                        common.rebindRegionEvents()
                    },
                })

                return ul
            },
            function(searchData) {
                var ul: JQuery = common.elem('countymulti-searchfor-list')
                var cri = $search.getCriteria(ul, searchData)
                if (!cri || cri.CriteriaId == '-1') return null
                var vals = cri.Values.split('|')

                console.log('countymulti-searchfor load ' + $search.getCriteria(ul, searchData).Values)
                //console.log(vals);
                //console.log("/Search/CountymultisListById?ids=" + vals[0]);

                common.selectedCounties = vals[0].split(',')

                ul.html('')
                ul.attr('data-value', vals[0])

                // and show the multi part of the page
                common.elem('county-section-multi').removeClass('search-section-disabled').show()
                common.elem('county-section-single').addClass('search-section-disabled').hide()

                $ajax.post({
                    loadingText: 'Hämtar län...',
                    url: '/Search/CountiesListById',
                    data: {
                        ids: vals[0],
                    },
                    dataType: 'html',
                    success: function(res) {
                        ul.html(res)
                        common.count(ul, true)
                        common.rebindCountyEvents()
                    },
                })

                return ul
            },
            function(searchData) {
                console.log('checking region single')
                // NOTE: special handling if region was included, then switch over from multi to single part of the geo search
                var ul: JQuery = common.elem('region')
                var cri = $search.getCriteria(ul, searchData)
                if (!cri || cri.CriteriaId == '-1') return null

                console.log('showing region single')

                common.elem('region-section-multi').addClass('search-section-disabled').hide()
                common.elem('region-section-single').removeClass('search-section-disabled').show()

                return null
            },
            function(searchData) {
                console.log('checking county single')
                // NOTE: special handling if county was included, then switch over from multi to single part of the geo search
                var ul: JQuery = common.elem('county')
                var cri = $search.getCriteria(ul, searchData)
                if (!cri || cri.CriteriaId == '-1') return null

                console.log('showing county single')

                common.elem('county-section-multi').addClass('search-section-disabled').hide()
                common.elem('county-section-single').removeClass('search-section-disabled').show()

                return null
            },
            function(searchData) {
                var btns: JQuery = common.elem('change')
                var date: JQuery = common.elem('change-date')

                var vals = $search.getCriteria(btns, searchData).Values.split('|')

                btns.find('button').each(function() {
                    var thisval = $(this).attr('data-value')

                    console.log('indexOf ' + vals[0] + ' | ' + thisval + ': ' + vals[0].indexOf(thisval))

                    if (vals[0].indexOf(thisval) >= 0) {
                        $(this).addClass('bcfla-checked')
                        console.log(thisval + ' check')
                    } else {
                        $(this).removeClass('bcfla-checked')
                    }
                })

                date.val(vals[1])

                //tbareamin.val(vals[0]);
                //tbareamax.val(vals[1]);
                //tbsummin.val(vals[0]);
                //tbsummax.val(vals[1]);
                //tbdatefrom.val(vals[2]);
                //tbdateto.val(vals[3]);

                return btns
            },
        ]

        common.formCustomFieldsReset = [
            function(changedCriterias) {
                var el: JQuery = common.elem('trade-searchfor-list')
                var changed: boolean = el.find('li').length > 0
                el.html('')
                common.elem('trade-searchresult-list').html('')
                if (changed) changedCriterias.push(el)
            },
            function(changedCriterias) {
                var el: JQuery = common.elem('district-searchfor-list')
                var changed: boolean = el.find('li').length > 0
                var disabled: boolean = el.parents('.search-section-disabled').length > 0

                el.html("<li class='disabled'>-- Alla distrikt --</li>")
                el.attr('data-value', '')

                common.elem('district-searchresult-list').html("<li class='disabled'>-- Välj kommun först --</li>")
                common.selectedDistricts = []

                if (changed && !disabled) changedCriterias.push(el)
            },
            function(changedCriterias) {
                var el: JQuery = common.elem('regionmulti-searchfor-list')
                var changed: boolean = el.find('li').length > 0
                var disabled: boolean = el.parents('.search-section-disabled').length > 0

                el.html("<li class='disabled'>-- Alla län --</li>")
                el.attr('data-value', '')

                common.selectedRegions = []

                if (changed && !disabled) {
                    changedCriterias.push(el)
                    common.fetchRegions()
                }
            },
            function(changedCriterias) {
                var el: JQuery = common.elem('countymulti-searchfor-list')
                var changed: boolean = el.find('li').length > 0
                var disabled: boolean = el.parents('.search-section-disabled').length > 0

                el.html("<li class='disabled'>-- Alla kommuner --</li>")
                el.attr('data-value', '')

                common.elem('countymulti-searchresult-list').html("<li class='disabled'>-- Välj län först --</li>")
                common.selectedCounties = []

                if (changed && !disabled) changedCriterias.push(el)
            },
            function(changedCriterias) {
                setTempflagId('', '-1', ['[Inga flaggor valda]'], [])
                setTempflagId('ex', '-1', ['[Inga flaggor valda]'], [])
            },
        ]

        common.formCheckboxes.push(common.elem('hasprivatecompany'))
        common.formCheckboxesReset.push(common.elem('hasprivatecompany'))
        common.bindCountEventCheckbox(common.elem('hasprivatecompany'))

        common.formCheckboxes.push(common.elem('hascompany'))
        common.formCheckboxesReset.push(common.elem('hascompany'))
        common.bindCountEventCheckbox(common.elem('hascompany'))

        common.formCheckboxes.push(common.elem('excludedead'))
        common.formCheckboxesReset.push(common.elem('excludedead'))
        common.bindCountEventCheckbox(common.elem('excludedead'))

        common.bindCountEventCheckbox(common.elem('stables'))
        common.bindCountEventCheckbox(common.elem('ownercreated-type'))

        if (common.options.searchSex) common.formCheckboxes.push(common.elem('sex'))
        if (common.options.searchSex) common.formCheckboxesReset.push(common.elem('sex'))
        if (common.options.searchSex) common.bindCountEventCheckbox(common.elem('sex'))

        if (common.options.searchPhone) common.formCheckboxes.push(common.elem('phone'))
        if (common.options.searchPhone) common.formCheckboxesReset.push(common.elem('phone'))
        if (common.options.searchPhone) common.bindCountEventCheckbox(common.elem('phone'))

        if (common.options.searchUtbonarbo) common.formCheckboxes.push(common.elem('utbonarbo'))
        if (common.options.searchUtbonarbo) common.formCheckboxesReset.push(common.elem('utbonarbo'))
        if (common.options.searchUtbonarbo) common.bindCountEventCheckbox(common.elem('utbonarbo'))

        if (common.options.searchFunctionAnimals) common.formCheckboxes.push(common.elem('function-animals'))
        if (common.options.searchFunctionAnimals) common.formCheckboxesReset.push(common.elem('function-animals'))
        if (common.options.searchFunctionAnimals) common.bindCountEventCheckbox(common.elem('function-animals'))

        if (common.options.searchFunctionCultivation) common.formCheckboxes.push(common.elem('function-cultivation'))
        if (common.options.searchFunctionCultivation)
            common.formCheckboxesReset.push(common.elem('function-cultivation'))
        if (common.options.searchFunctionCultivation) common.bindCountEventCheckbox(common.elem('function-cultivation'))

        if (common.options.searchFunctionVehicle) common.formCheckboxes.push(common.elem('function-vehicle'))
        if (common.options.searchFunctionVehicle) common.formCheckboxesReset.push(common.elem('function-vehicle'))
        if (common.options.searchFunctionVehicle) common.bindCountEventCheckbox(common.elem('function-vehicle'))

        if (common.options.searchEuSupport) common.formCheckboxes.push(common.elem('function-eusupport'))
        if (common.options.searchEuSupport) common.formCheckboxesReset.push(common.elem('function-eusupport'))
        if (common.options.searchEuSupport) common.bindCountEventCheckbox(common.elem('function-eusupport'))

        if (common.options.searchBuildings) {
            common.initRangeWithSlider(
                common.elem('buildings-countslider'),
                common.elem('buildings-countmin'),
                common.elem('buildings-countmax'),
            )
            common.initRangeWithSlider(
                common.elem('buildingssmall-countslider'),
                common.elem('buildingssmall-countmin'),
                common.elem('buildingssmall-countmax'),
            )
            common.initRangeWithSlider(
                common.elem('buildingsecon-countslider'),
                common.elem('buildingsecon-countmin'),
                common.elem('buildingsecon-countmax'),
            )

            common.formSliders.push(common.elem('buildings-countslider'))
            common.formSliders.push(common.elem('buildingssmall-countslider'))
            common.formSliders.push(common.elem('buildingsecon-countslider'))

            common.formRanges.push([
                common.elem('buildings-countmin'),
                common.elem('buildings-countmax'),
                common.elem('buildings-countslider'),
            ])
            common.formRanges.push([
                common.elem('buildingssmall-countmin'),
                common.elem('buildingssmall-countmax'),
                common.elem('buildingssmall-countslider'),
            ])
            common.formRanges.push([
                common.elem('buildingsecon-countmin'),
                common.elem('buildingsecon-countmax'),
                common.elem('buildingsecon-countslider'),
            ])
        }

        if (common.options.searchTaxValue) {
            common.initRangeWithSlider(
                common.elem('tax-sumslider'),
                common.elem('tax-summin'),
                common.elem('tax-summax'),
            )
            common.initRangeWithSlider(
                common.elem('taxland-sumslider'),
                common.elem('taxland-summin'),
                common.elem('taxland-summax'),
            )
            common.initRangeWithSlider(
                common.elem('taxbuilding-sumslider'),
                common.elem('taxbuilding-summin'),
                common.elem('taxbuilding-summax'),
            )
            common.initRangeWithSlider(
                common.elem('taxstructsmall-sumslider'),
                common.elem('taxstructsmall-summin'),
                common.elem('taxstructsmall-summax'),
            )
            common.initRangeWithSlider(
                common.elem('taxforest-sumslider'),
                common.elem('taxforest-summin'),
                common.elem('taxforest-summax'),
            )

            common.formSliders.push(common.elem('tax-sumslider'))
            common.formSliders.push(common.elem('taxland-sumslider'))
            common.formSliders.push(common.elem('taxbuilding-sumslider'))
            common.formSliders.push(common.elem('taxstructsmall-sumslider'))
            common.formSliders.push(common.elem('taxforest-sumslider'))

            common.formRanges.push([common.elem('tax-summin'), common.elem('tax-summax'), common.elem('tax-sumslider')])
            common.formRanges.push([
                common.elem('taxland-summin'),
                common.elem('taxland-summax'),
                common.elem('taxland-sumslider'),
            ])
            common.formRanges.push([
                common.elem('taxbuilding-summin'),
                common.elem('taxbuilding-summax'),
                common.elem('taxbuilding-sumslider'),
            ])
            common.formRanges.push([
                common.elem('taxstructsmall-summin'),
                common.elem('taxstructsmall-summax'),
                common.elem('taxstructsmall-sumslider'),
            ])
            common.formRanges.push([
                common.elem('taxforest-summin'),
                common.elem('taxforest-summax'),
                common.elem('taxforest-sumslider'),
            ])
        }

        if (common.options.searchVehicles) {
            common.formCheckboxesReset.push(common.elem('vehicletype'))
            common.formCheckboxesReset.push(common.elem('vehiclebrand'))
            common.formCheckboxesReset.push(common.elem('vehiclestatus'))

            common.initRangeWithSlider(
                common.elem('vehicles-countslider'),
                common.elem('vehicles-countmin'),
                common.elem('vehicles-countmax'),
            )
            common.initRangeWithSlider(
                common.elem('vehicletractors-countslider'),
                common.elem('vehicletractors-countmin'),
                common.elem('vehicletractors-countmax'),
            )
            common.initRangeWithSlider(
                common.elem('vehicleskotares-countslider'),
                common.elem('vehicleskotares-countmin'),
                common.elem('vehicleskotares-countmax'),
            )
            common.initRangeWithSlider(
                common.elem('vehicles-yearslider'),
                common.elem('vehicles-yearmin'),
                common.elem('vehicles-yearmax'),
            )
            common.initRangeWithSlider(
                common.elem('vehicles-weightslider'),
                common.elem('vehicles-weightmin'),
                common.elem('vehicles-weightmax'),
            )
            common.initRangeWithSlider(
                common.elem('vehicles-horsepowerslider'),
                common.elem('vehicles-horsepowermin'),
                common.elem('vehicles-horsepowermax'),
            )

            common.formSliders.push(common.elem('vehicles-countslider'))
            common.formSliders.push(common.elem('vehicletractors-countslider'))
            common.formSliders.push(common.elem('vehicleskotares-countslider'))
            common.formSliders.push(common.elem('vehicles-yearslider'))
            common.formSliders.push(common.elem('vehicles-weightslider'))
            common.formSliders.push(common.elem('vehicles-horsepowerslider'))

            var debouncedCountVehicles = _.debounce(function() {
                common.count(common.elem('vehicles-yearmin'))
            }, common.debounceDelay)

            common.elem('vehicles-yearmin').keyup(debouncedCountVehicles)
            common.elem('vehicles-yearmin').blur(debouncedCountVehicles)
            common.elem('vehicles-yearmin').change(debouncedCountVehicles)

            common.elem('vehicles-yearmax').keyup(debouncedCountVehicles)
            common.elem('vehicles-yearmax').blur(debouncedCountVehicles)
            common.elem('vehicles-yearmax').change(debouncedCountVehicles)

            common.elem('vehicles-purchaseyearmin').keyup(debouncedCountVehicles)
            common.elem('vehicles-purchaseyearmin').blur(debouncedCountVehicles)
            common.elem('vehicles-purchaseyearmin').change(debouncedCountVehicles)

            common.elem('vehicles-purchaseyearmax').keyup(debouncedCountVehicles)
            common.elem('vehicles-purchaseyearmax').blur(debouncedCountVehicles)
            common.elem('vehicles-purchaseyearmax').change(debouncedCountVehicles)

            common.elem('vehicles-weightmin').keyup(debouncedCountVehicles)
            common.elem('vehicles-weightmin').blur(debouncedCountVehicles)
            common.elem('vehicles-weightmin').change(debouncedCountVehicles)

            common.elem('vehicles-weightmax').keyup(debouncedCountVehicles)
            common.elem('vehicles-weightmax').blur(debouncedCountVehicles)
            common.elem('vehicles-weightmax').change(debouncedCountVehicles)

            common.elem('vehicles-horsepowermin').keyup(debouncedCountVehicles)
            common.elem('vehicles-horsepowermin').blur(debouncedCountVehicles)
            common.elem('vehicles-horsepowermin').change(debouncedCountVehicles)

            common.elem('vehicles-horsepowermax').keyup(debouncedCountVehicles)
            common.elem('vehicles-horsepowermax').blur(debouncedCountVehicles)
            common.elem('vehicles-horsepowermax').change(debouncedCountVehicles)

            common.elem('vehiclemodel').keyup(debouncedCountVehicles)
            common.elem('vehiclemodel').blur(debouncedCountVehicles)
            common.elem('vehiclemodel').change(debouncedCountVehicles)

            common.elem('vehicleregno').keyup(debouncedCountVehicles)
            common.elem('vehicleregno').blur(debouncedCountVehicles)
            common.elem('vehicleregno').change(debouncedCountVehicles)

            common.elem('vehicleownerscount').keyup(debouncedCountVehicles)
            common.elem('vehicleownerscount').blur(debouncedCountVehicles)
            common.elem('vehicleownerscount').change(debouncedCountVehicles)

            common.elem('vehicletype button').click(debouncedCountVehicles)
            common.elem('vehiclebrand button').click(debouncedCountVehicles)
            common.elem('vehiclestatus button').click(debouncedCountVehicles)

            common.formRanges.push([
                common.elem('vehicles-countmin'),
                common.elem('vehicles-countmax'),
                common.elem('vehicles-countslider'),
            ])
            common.formRanges.push([
                common.elem('vehicletractors-countmin'),
                common.elem('vehicletractors-countmax'),
                common.elem('vehicletractors-countslider'),
            ])
            common.formRanges.push([
                common.elem('vehicleskotares-countmin'),
                common.elem('vehicleskotares-countmax'),
                common.elem('vehicleskotares-countslider'),
            ])
        }

        if (common.options.searchFelling) {
            var debouncedCountFelling = _.debounce(function() {
                common.count(common.elem('felling-areamin'))
            }, common.debounceDelay)

            common.elem('felling-company').keyup(debouncedCountFelling)
            common.elem('felling-company').blur(debouncedCountFelling)
            common.elem('felling-company').change(debouncedCountFelling)

            common.elem('felling-areamin').keyup(debouncedCountFelling)
            common.elem('felling-areamin').blur(debouncedCountFelling)
            common.elem('felling-areamin').change(debouncedCountFelling)

            common.elem('felling-areamax').keyup(debouncedCountFelling)
            common.elem('felling-areamax').blur(debouncedCountFelling)
            common.elem('felling-areamax').change(debouncedCountFelling)

            common.elem('felling-datefrom').keyup(debouncedCountFelling)
            common.elem('felling-datefrom').blur(debouncedCountFelling)
            common.elem('felling-datefrom').change(debouncedCountFelling)

            common.elem('felling-dateto').keyup(debouncedCountFelling)
            common.elem('felling-dateto').blur(debouncedCountFelling)
            common.elem('felling-dateto').change(debouncedCountFelling)

            common.elem('felling-hascompany button').click(debouncedCountFelling)
            common.elem('felling-invert button').click(debouncedCountFelling)

            common.elem('felling-company').autocomplete({
                source: '/Search/FellingAgentAutoComplete',
                minLength: 1,
                select: function(event, ui) {
                    common.elem('felling-company').val(ui.item.value)
                    common.count(common.elem('felling-company'), true)
                },
                autoFocus: true,
                delay: 200,
                appendTo: '.' + common.options.pagePrefix + '-search-box',
            })
        }

        if (common.options.searchTransfer) {
            var debouncedCountTransfer = _.debounce(function() {
                common.count(common.elem('transfer-areamin'))
            }, common.debounceDelay)

            common.elem('transfer-areamin').keyup(debouncedCountTransfer)
            common.elem('transfer-areamin').blur(debouncedCountTransfer)
            common.elem('transfer-areamin').change(debouncedCountTransfer)

            common.elem('transfer-areamax').keyup(debouncedCountTransfer)
            common.elem('transfer-areamax').blur(debouncedCountTransfer)
            common.elem('transfer-areamax').change(debouncedCountTransfer)

            common.elem('transfer-summin').keyup(debouncedCountTransfer)
            common.elem('transfer-summin').blur(debouncedCountTransfer)
            common.elem('transfer-summin').change(debouncedCountTransfer)

            common.elem('transfer-summax').keyup(debouncedCountTransfer)
            common.elem('transfer-summax').blur(debouncedCountTransfer)
            common.elem('transfer-summax').change(debouncedCountTransfer)

            common.elem('transfer-datefrom').keyup(debouncedCountTransfer)
            common.elem('transfer-datefrom').blur(debouncedCountTransfer)
            common.elem('transfer-datefrom').change(debouncedCountTransfer)

            common.elem('transfer-dateto').keyup(debouncedCountTransfer)
            common.elem('transfer-dateto').blur(debouncedCountTransfer)
            common.elem('transfer-dateto').change(debouncedCountTransfer)

            common.elem('transfer-buytype button').click(debouncedCountTransfer)
            common.elem('transfer-type button').click(debouncedCountTransfer)

            common.elem('transfer-type button').on('click', () => {
                const cbltypeval: string = $form.getCheckboxlistValues(common.elem('transfer-type')).join(',')
                if (cbltypeval == '1') {
                    // only "helöverlåtelse" selected, then we can search in sum and buytype
                    common
                        .elem('transfer-buytype')
                        .find('button')
                        .prop('disabled', false)
                        .removeClass('bcfla-btn--disabled')

                    common.elem('transfer-summin').prop('disabled', false)
                    common.elem('transfer-summax').prop('disabled', false)
                } else {
                    // noep
                    common
                        .elem('transfer-buytype')
                        .find('button')
                        .removeClass('bcfla-checked')
                        .prop('disabled', true)
                        .addClass('bcfla-btn--disabled')

                    common.elem('transfer-summin').prop('disabled', true).val('')
                    common.elem('transfer-summax').prop('disabled', true).val('')

                    common.count(common.elem('transfer-buytype'), true)
                    common.count(common.elem('transfer-summin'), true)
                }
            })
        }

        if (common.options.searchVehicles) {
            common.elem('vehiclemodel').autocomplete({
                source: function(request, response) {
                    var selectedBrands = $form.getCheckboxlistValues(common.elem('vehiclebrand'))
                    $ajax.post({
                        loadingText: 'Söker...',
                        url: '/Search/VehicleModelAutoComplete',
                        dataType: 'json',
                        data: {
                            brands: selectedBrands.join(','),
                            term: request.term,
                        },
                        success: function(res) {
                            response(res)
                        },
                    })
                },
                minLength: 1,
                select: function(event, ui) {
                    common.elem('vehiclemodel').val(ui.item.value)
                    common.count(common.elem('vehiclemodel'), true)
                },
                autoFocus: true,
                delay: 200,
                appendTo: '.' + common.options.pagePrefix + '-search-box',
            })
        }

        if (common.options.searchCompanyType) common.formCheckboxes.push(common.elem('company-type'))
        if (common.options.searchCompanyType) common.formCheckboxesReset.push(common.elem('company-type'))
        if (common.options.searchCompanyType) common.bindCountEventCheckbox(common.elem('company-type'))

        if (common.options.searchTrade) common.bindCountEventTextbox(common.elem('trade'))

        common.bindCountEventTextbox(common.elem('note-freetext'))
        common.bindCountEventTextbox(common.elem('note-datefrom'))
        common.bindCountEventTextbox(common.elem('note-dateto'))
        common.bindCountEventTextbox(common.elem('note-returndatefrom'))
        common.bindCountEventTextbox(common.elem('note-returndateto'))
        common.bindCountEventCheckbox(common.elem('note-types'))

        common.bindCountEventCheckbox(common.elem('change'))
        common.bindCountEventTextbox(common.elem('change-date'))

        common.bindCountEventTextbox(common.elem('city'))
        common.bindCountEventTextbox(common.elem('zipno'))
        common.bindCountEventDropdown(common.elem('region'))
        common.bindCountEventDropdown(common.elem('county'))

        common.bindCountEventTextbox(common.elem('ownercreated-datefrom'))
        common.bindCountEventTextbox(common.elem('ownercreated-dateto'))

        common.initRangeWithSlider(
            common.elem('birthyear-slider'),
            common.elem('birthyear-min'),
            common.elem('birthyear-max'),
        )
        common.initRangeWithSlider(
            common.elem('areatotal-slider'),
            common.elem('areatotal-min'),
            common.elem('areatotal-max'),
        )
        common.initRangeWithSlider(
            common.elem('areatotalind-slider'),
            common.elem('areatotalind-min'),
            common.elem('areatotalind-max'),
        )
        common.initRangeWithSlider(
            common.elem('areafield-slider'),
            common.elem('areafield-min'),
            common.elem('areafield-max'),
        )
        common.initRangeWithSlider(
            common.elem('areaforest-slider'),
            common.elem('areaforest-min'),
            common.elem('areaforest-max'),
        )
        if (common.options.searchPropertyOwnedPart)
            common.initRangeWithSlider(
                common.elem('areaprop-slider'),
                common.elem('areaprop-min'),
                common.elem('areaprop-max'),
            )
        if (common.options.searchPropertyOwnedPart)
            common.initRangeWithSlider(
                common.elem('owpaprop-slider'),
                common.elem('owpaprop-min'),
                common.elem('owpaprop-max'),
            )
        common.initRangeWithSlider(
            common.elem('felling-areaslider'),
            common.elem('felling-areamin'),
            common.elem('felling-areamax'),
        )
        common.initRangeWithSlider(
            common.elem('transfer-areaslider'),
            common.elem('transfer-areamin'),
            common.elem('transfer-areamax'),
        )
        common.initRangeWithSlider(
            common.elem('transfer-sumslider'),
            common.elem('transfer-summin'),
            common.elem('transfer-summax'),
        )
        common.initRangeWithSlider(
            common.elem('virkesforrad-countslider'),
            common.elem('virkesforrad-countmin'),
            common.elem('virkesforrad-countmax'),
        )
        common.initRangeWithSlider(
            common.elem('bonitet-countslider'),
            common.elem('bonitet-countmin'),
            common.elem('bonitet-countmax'),
        )

        common.elem('vehicles-purchaseyearmin').datepicker()
        common.elem('vehicles-purchaseyearmax').datepicker()

        // fritext
        var debouncedCountFritext = _.debounce(function() {
            common.count(common.elem('freetextname'))
        }, common.debounceDelay)
        $('#' + common.elemId('freetextname-cbl') + ' > button').click(function() {
            debouncedCountFritext()
        })
        common.elem('freetextname').on('blur', function() {
            debouncedCountFritext()
        })
        common.elem('freetextname').on('keyup', function() {
            debouncedCountFritext()
        })

        // sni
        if (common.options.searchTrade) {
            var tradeSearchDebounce = _.debounce(function() {
                var list: JQuery = common.elem('trade-searchfor-list')
                var exclude: string[] = []
                list.find('li').each(function() {
                    exclude.push($(this).attr('data-id'))
                })

                $ajax.post({
                    loadingText: 'Söker SNI...',
                    url: '/Search/TradesList',
                    data: {
                        search: common.elem('trade-search').val(),
                        exclude: exclude.join(','),
                    },
                    dataType: 'html',
                    success: function(res) {
                        common.elem('trade-searchresult-list').html(res)
                        rebindTradeEvents()
                    },
                })
            }, common.debounceDelay)
            common.elem('trade-search').on('keyup', function() {
                tradeSearchDebounce()
            })
            common.elem('trade-search').on('change', function() {
                tradeSearchDebounce()
            })
        }

        // ladda-ner-knappar
        common.elemByClass('submit-dropdown-button').click(function() {
            var btn: JQuery = $(this)
            showGetFileModal(btn.attr('data-id'), btn.attr('data-gdpr'))
        })

        common.elem('flags20-modal').click(function() {
            var flagids: string = common.elem('flags20-ids').val()
            var doclear: boolean = flagids.length === 0 || flagids === '-1'
            $modal.load('/Flag/SearchTempflagModal', { clear: doclear, prefix: '' }, false, true, false)
        })

        common.elem('flags20-clear').click(function() {
            setTempflagId('', '-1', ['[Inga flaggor valda]'], [])
        })

        common.elem('flags20-info').click(function() {
            $modal.load('/Flag/SearchTempflagModalInfo', { info: 'tempflag' })
        })

        common.elemByClass('disabled-form-group').click(function() {
            $modal.show($resources.text.serviceDisabled)
        })

        common.elem('transfer-to-property').click(function() {
            console.log('total-no!', common.elem('total-no'), common.elem('total-no').html())

            $ajax.post({
                loadingText: 'Flyttar över sökresultat...',
                url: '/Property/SaveOwnerSearchToTempFlag',
                data: {
                    criteriaData: JSON.stringify(common.serializeForm()),
                    totalNo: common.elem('total-no').html(),
                },
                success: function(res) {
                    if (res.Ok) {
                        location.href = '/Search/PropertyForm'
                    } else {
                        $msg.showError(res.Message)
                    }
                },
            })
        })

        common.init()
        common.fetchRegions(function() {
            // load latest search after regions have been fetched the first time
            // otherwise it could go:
            //   1 start to fetch all regions
            //   2 load latest search
            //   3 set regions from latest search
            //   4 all regions finishes loading and overwrites latest search regions
            if ($options.fetchSearchId && $options.fetchSearchId > 0) common.fetchSavedSearch($options.fetchSearchId)
            else common.loadLatestSearch('/Search/FetchLatestForOwner')
        })

        $blogpostpopup.load(1)
    }

    export function setTempflagId(prefix: string, id: string, names: string[], ids: string[]): void {
        common.elem(prefix + 'flags20-id').attr('data-previous-value', '-666') // to make sure the value is seen as changed and the count is reevalued
        common.elem(prefix + 'flags20-id').val(id)
        common.elem(prefix + 'flags20-ids').val(ids.join(','))
        common.elem(prefix + 'flags20-names').html(names.join('<br/>'))
        common.count(common.elem(prefix + 'flags20-ids'))
    }

    function rebindTradeEvents(): void {
        common.elem('trade-formgroup').find('.bcfla-tooltip').tooltip('destroy')
        common.elem('trade-formgroup').find('.bcfla-tooltip').tooltip({ delay: 300, html: true, placement: 'top' })

        common.elem('trade-searchresult-list li span').off('click')
        common.elem('trade-searchresult-list li span').on('click', function(event) {
            $modal.show($(this).attr('data-description'))
            event.cancelBubble = true
            return false
        })

        common.elem('trade-searchresult-list li').off('click')
        common.elem('trade-searchresult-list li').on('click', function() {
            console.log('> ' + $(this).attr('data-id'))

            $(this).appendTo(common.elem('trade-searchfor-list'))

            common.count(common.elem('trade-searchfor-list'))

            rebindTradeEvents()
        })

        common.elem('trade-searchfor-list li').off('click')
        common.elem('trade-searchfor-list li').on('click', function() {
            console.log('< ' + $(this).attr('data-id'))

            $(this).appendTo(common.elem('trade-searchresult-list'))

            common.count(common.elem('trade-searchfor-list'))

            rebindTradeEvents()
        })
    }

    function showGetFileModal(templateId: string, gdprSafe: string): void {
        $modal.load(
            '/Export/OwnerGetFileModal',
            { gdprSafe: gdprSafe, templateId: templateId, totalNo: common.elem('total-no').html() },
            false,
            false,
            false,
        )
    }

    export function getFile(templateId: string, gdprSafe: string, filename: string, excludedead: string): void {
        var f = (function() {
            callQueue.queue(function(next) {
                $modal.show('Sparar sökresultat till fil...')

                $ajax.post({
                    loadingText: 'Sparar sökresultat till fil...',
                    url: '/Export/OwnerFile',
                    data: {
                        criteriaData: JSON.stringify(common.serializeForm()),
                        totalNo: common.elem('total-no').html(),
                        templateId: templateId,
                        gdprSafe: gdprSafe,
                        filename: filename,
                        excludedead: excludedead,
                        sortId: common.sortId,
                        sortAsc: common.sortAsc,
                    },
                    success: function(res) {
                        if (res.Ok) {
                            if (res.OverLimit) {
                                $modal.show(
                                    '<h4>Export startad</h4><p>Ditt data håller på att exporteras. Pga datamängden behöver detta först godkännas av en administratör. När det är gjort, kommer du få ett mail med en länk till din fil.</p><p>Har du frågor kring detta - kontakta supporten på <a href="tel:0707254618">070-725 46 18</a> eller maila oss på <a href="mailto:camo@biscom.se">camo@biscom.se</a>.</p><p>Mvh<br/>LantbruksFaktaDigital / Biscom<br/><a href="http://www.lantbruksfaktadigital.se">www.lantbruksfaktadigital.se</a><br/>Carl-Johan Mossberg<br/><a href="tel:0707254618">070-725 46 18</a><br/><a href="mailto:camo@biscom.se">camo@biscom.se</a></p>',
                                    true,
                                    false,
                                )
                            } else {
                                $modal.show(
                                    '<h4>Export startad</h4><p>Ditt data håller på att exporteras. När det är klart, kommer du få ett mail med en länk till din fil.</p><p>Har du frågor kring detta - kontakta supporten på <a href="tel:0707254618">070-725 46 18</a> eller maila oss på <a href="mailto:camo@biscom.se">camo@biscom.se</a>.</p><p>Mvh<br/>LantbruksFaktaDigital / Biscom<br/><a href="http://www.lantbruksfaktadigital.se">www.lantbruksfaktadigital.se</a><br/>Carl-Johan Mossberg<br/><a href="tel:0707254618">070-725 46 18</a><br/><a href="mailto:camo@biscom.se">camo@biscom.se</a></p>',
                                    true,
                                    false,
                                )
                            }
                        } else {
                            $modal.hide()
                            $msg.showError(res.Message)
                        }
                    },
                    complete: function() {
                        next()
                    },
                })
            })
        })()
    }
}

export module ownerlist {
    var sidemap: google.maps.Map
    var undermap: google.maps.Map
    var undermapId: string
    var sidemapId: string
    var largeMap: boolean
    var options: any
    var heightObject: any

    export function init($options: any): void {
        options = $.extend(true, {}, $options)

        sidemapId = options.pagePrefix + '-sidemap'
        undermapId = options.pagePrefix + '-undermap'

        heightObject = new $ubh.uniformBoxHeights({
            listElementsSelector: '.' + options.pagePrefix + '-list-row > div > .bcfla-box',
        })

        if (!options.exportAccount) {
            $('.' + options.pagePrefix + '-td-name a, .' + options.pagePrefix + '-td-notes a').click(function(e) {
                console.log('name klick')
                var url = $(this).attr('data-link')
                $modal.load(url, { edit: 'notes' }, false, true, true)
                e.preventDefault()
            })
        }

        $('.' + options.pageName + ' .bcfla-th-sortable').click(function() {
            console.log('klick')
            common.setSort(parseInt($(this).attr('data-sortid')), $(this).attr('data-sortasc'))
            common.getList(1)
        })

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-addordelete button').click(function() {
            var addTo = $(this).attr('data-value') == 'true'
            if (addTo) {
                $('.' + options.pageName + ' .' + options.pagePrefix + '-flagall-addordeletelabel-addto').removeClass(
                    'bcfla-hidden',
                )
                $('.' + options.pageName + ' .' + options.pagePrefix + '-flagall-addordeletelabel-deletefrom').addClass(
                    'bcfla-hidden',
                )
            } else {
                $('.' + options.pageName + ' .' + options.pagePrefix + '-flagall-addordeletelabel-addto').addClass(
                    'bcfla-hidden',
                )
                $(
                    '.' + options.pageName + ' .' + options.pagePrefix + '-flagall-addordeletelabel-deletefrom',
                ).removeClass('bcfla-hidden')
            }
        })

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-currentpage button').click(function() {
            var count = $(this).attr('data-value') == 'count'
            if (count) {
                $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-count').removeClass('bcfla-hidden')
            } else {
                $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-count').addClass('bcfla-hidden')
            }
        })

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-flags span').click(function() {
            $(this).toggleClass('bcfla-label-unchecked')
            setTimeout(function() {
                checkFlagAllSelected()
            }, 200)
        })

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-submit').click(function() {
            submitFlagAll()
        })

        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-count input').keyup(function() {
            $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-countdisplay').html($(this).val())
        })

        $flag.bindToggleFlagEvents($('.' + options.pagePrefix + '-td-flags'))
        $help.tooltips.initializeTooltips($('.' + $options.pageName))

        $('.' + options.pagePrefix + '-sidemap-btn-toggle').click(function() {
            if (!largeMap) {
                $('.' + options.pagePrefix + '-sidemap-btn-toggle').toggle()
                $('.' + options.pagePrefix + '-undermap-btn-show').toggle()
                $('.' + options.pagePrefix + '-list-col').toggleClass(
                    $('.' + options.pagePrefix + '-list-col').attr('data-nomap-class'),
                )
                $('.' + options.pagePrefix + '-list-col').toggleClass(
                    $('.' + options.pagePrefix + '-list-col').attr('data-map-class'),
                )
                $('.' + options.pagePrefix + '-sidemap-col').toggleClass('bcfla-hidden')
                if (!$('.' + options.pagePrefix + '-sidemap-col').hasClass('bcfla-hidden')) initSideMap()
            } else {
                $('.' + options.pagePrefix + '-sidemap-btn-toggle').toggle()
                $('.' + options.pagePrefix + '-undermap-btn-hide').toggle()
                $('.' + options.pagePrefix + '-undermap-box').toggleClass('bcfla-hidden')
                if (!$('.' + options.pagePrefix + '-undermap-box').hasClass('bcfla-hidden')) initUnderMap()
            }

            common.mapVisible = !common.mapVisible

            if (common.mapVisible) {
                $('.' + options.pagePrefix + '-maphelp-btn').show()
            } else {
                $('.' + options.pagePrefix + '-maphelp-btn').hide()
            }
        })

        $('.' + options.pagePrefix + '-undermap-btn-toggle').click(function() {
            largeMap = !largeMap

            $('.' + options.pagePrefix + '-undermap-btn-show').toggle()
            $('.' + options.pagePrefix + '-undermap-btn-hide').toggle()

            $('.' + options.pagePrefix + '-list-col').toggleClass(
                $('.' + options.pagePrefix + '-list-col').attr('data-nomap-class'),
            )
            $('.' + options.pagePrefix + '-list-col').toggleClass(
                $('.' + options.pagePrefix + '-list-col').attr('data-map-class'),
            )

            $('.' + options.pagePrefix + '-sidemap-col').toggleClass('bcfla-hidden')

            $('.' + options.pagePrefix + '-undermap-box').toggleClass('bcfla-hidden')

            if (!$('.' + options.pagePrefix + '-undermap-box').hasClass('bcfla-hidden')) initUnderMap()
            if (!$('.' + options.pagePrefix + '-sidemap-col').hasClass('bcfla-hidden')) initSideMap()

            common.largeMap = largeMap
        })

        $('.' + options.pagePrefix + '-maphelp-btn').click(function() {
            $modal.load('/Owner/OwnerMapDescription', { desc: 'map' })
        })

        $('.' + options.pagePrefix + '-td-veh').click(function() {
            $modal.load(
                '/Vehicle/ListVehiclesForOwner',
                {
                    id: $(this).attr('data-id'),
                    inuse: $(this).attr('data-inuse'),
                    type: $(this).attr('data-type'),
                },
                true,
                false,
                true,
            )
        })

        $helpers.partialPageInit($('.' + options.pageName))
        loadExtras($('.' + options.pageName), $.extend({}, options))
    }

    var currentExtrasRoot: JQuery

    function loadExtras(root: JQuery, listOptions: any): void {
        currentExtrasRoot = root
        var contextElement = root.find('.bcfla-owner-list-context')
        if (!contextElement.length || root.data('extras-started')) return
        root.data('extras-started', true)
        var context = JSON.parse(contextElement.text())
        var payload = JSON.stringify({ context: context })

        function isCurrent(): boolean {
            return currentExtrasRoot[0] === root[0]
                && $.contains(document.documentElement, root[0])
                && root.attr('data-owner-list-sequence') === String(context.Sequence)
        }

        function failed(attempt: number): void {
            if (!isCurrent()) return
            if (attempt === 0) {
                setTimeout(() => request(1), 1000)
            } else {
                $('<p class="bcfla-owner-extras-error text-danger" role="alert">')
                    .text('Kunde inte hämta flaggor, anteckningar och avverkningsuppgifter.')
                    .appendTo(root.find('.bcfla-box').first())
            }
        }

        function request(attempt: number): void {
            if (!isCurrent()) return
            $.ajax({
                type: 'POST',
                url: '/SearchV2/OwnerListExtras',
                contentType: 'application/json',
                dataType: 'json',
                data: payload,
                success: function(response) {
                    // Guard before the shared authorization handler can change the current page.
                    if (!isCurrent()) return
                    if (!$ajax.okResponseJson(response) || response.Sequence !== context.Sequence) return
                    root.find('[data-extra="flags"]').each(function() {
                        var placeholder = $(this)
                        var ownerId = Number(placeholder.attr('data-ownerid'))
                        var cell = placeholder.parent()
                        $.each(response.Flags, function(_, flag) {
                            var checked = response.OwnerFlags.some(item => item.EntityId === ownerId && item.FlagId === flag.Id)
                            $('<span class="bcfla-flagicon-toggle bcfla-tooltip">')
                                .toggleClass('bcfla-flagicon-disabled', response.EditableFlags.indexOf(flag.Id) < 0)
                                .css('color', flag.Color)
                                .attr({ 'data-ownerid': ownerId, 'data-flagid': flag.Id, title: flag.Name })
                                .append($('<span>').attr('class', checked ? 'fas fa-square' : 'far fa-square'))
                                .appendTo(cell)
                        })
                        placeholder.remove()
                        $flag.bindToggleFlagEvents(cell)
                        cell.find('.bcfla-tooltip').tooltip({ delay: 300, html: true, placement: 'top' })
                    })
                    root.find('[data-extra="notes"]').each(function() {
                        var placeholder = $(this)
                        var ownerId = Number(placeholder.attr('data-ownerid'))
                        var count = response.NoteCounts[ownerId] || 0
                        if (count > 0) {
                            var badge = $('<span>')
                                .addClass(listOptions.pagePrefix + '-notes-badge bcfla-tooltip bcfla-owner-noteslist-no-' + ownerId + ' bcfla-comment-badge')
                                .attr('data-id', ownerId).text(count)
                            var link = placeholder.find('a').detach().show().append(badge)
                            placeholder.replaceWith(link)
                            link.find('.bcfla-tooltip').tooltip({ delay: 300, html: true, placement: 'top' })
                        } else {
                            placeholder.remove()
                        }
                    })
                    root.find('[data-extra="fellings"], [data-extra="fellingAgents"]').each(function() {
                        var placeholder = $(this)
                        var summary = response.Fellings[placeholder.attr('data-ownerid')] || { Count: 0, AgentNames: [] }
                        if (placeholder.attr('data-extra') === 'fellings') {
                            placeholder.replaceWith(document.createTextNode(summary.Count > 0 ? summary.Count + ' st' : ''))
                        } else {
                            var agents = summary.AgentNames
                            var label = $('<span>').text(agents[0] || '')
                            if (agents.length > 1) {
                                label.addClass('bcfla-tooltip')
                                    .attr('title', agents.map(name => $('<span>').text(name).html()).join('<br/>'))
                                    .append($('<span class="bcfla-light-gray">').text(' (+' + (agents.length - 1) + ')'))
                            }
                            placeholder.replaceWith(label)
                            if (agents.length > 1) label.tooltip({ delay: 300, html: true, placement: 'top' })
                        }
                    })
                    var controls = root.find('.bcfla-owner-flag-controls')
                    var flags = controls.find('#' + listOptions.pagePrefix + '-flagall-flags')
                    $.each(response.Flags, function(_, flag) {
                        $('<span class="bcfla-label bcfla-label-unchecked">')
                            .css({ backgroundColor: flag.Color, borderColor: flag.Color })
                            .attr('data-flagid', flag.Id).text(flag.Name)
                            .click(function() {
                                $(this).toggleClass('bcfla-label-unchecked')
                                setTimeout(checkFlagAllSelected, 200)
                            }).appendTo(flags)
                    })
                    root.find('[data-extra="flagControls"]').remove()
                    controls.toggle(response.Flags.length > 0)
                },
                error: () => failed(attempt),
            })
        }

        request(0)
    }

    function initSideMap(): void {
        heightObject.setHeights()

        sidemap = $maps.initMap({
            mapElement: $('#' + options.pagePrefix + '-sidemap'),
            mapId: sidemapId,
            mapOptions: { zoom: 14 },
        })

        addMapMarkers(sidemap, sidemapId)

        $maps.zoomToFit({
            map: sidemap,
            mapId: sidemapId,
        })

        $maps.addClustering({
            map: sidemap,
            mapId: sidemapId,
        })
    }

    function initUnderMap(): void {
        undermap = $maps.initMap({
            mapElement: $('#' + options.pagePrefix + '-undermap'),
            mapId: undermapId,
            mapOptions: { zoom: 14 },
        })

        addMapMarkers(undermap, undermapId)

        $maps.zoomToFit({
            map: undermap,
            mapId: undermapId,
        })

        $maps.addClustering({
            map: undermap,
            mapId: undermapId,
        })
    }

    function addMapMarkers(map: google.maps.Map, mapId: string): void {
        $.each(options.mapLocations, function(idx, obj) {
            $maps.addMarker({
                image: $maps.markerImageDefault,
                location: new google.maps.LatLng(obj.lat, obj.long),
                map: map,
                mapId: mapId,
                no: idx,
                onOver: function(marker) {
                    $.each(obj.oid, function(idx, id) {
                        $('.' + options.pagePrefix + '-list-tr-a' + id).addClass('bcfla-selected')
                    })
                },
                onOut: function(marker) {
                    $.each(obj.oid, function(idx, id) {
                        $('.' + options.pagePrefix + '-list-tr-a' + id).removeClass('bcfla-selected')
                    })
                },
                onClick: function(marker) {
                    $ajax.post({
                        url: '/Owner/CoordsModal',
                        data: {
                            lat: obj.lat,
                            lon: obj.long,
                        },
                        dataType: 'html',
                        success: function(res) {
                            $modal.show(res, true, true, true)
                        },
                    })
                },
            })
        })
    }

    function checkFlagAllSelected() {
        var flagged = 0
        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-flags span').each(function() {
            if (!$(this).hasClass('bcfla-label-unchecked')) flagged++
        })
        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-submit').prop('disabled', flagged === 0)
    }

    function submitFlagAll() {
        var flags: string[] = []
        $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-flags span').each(function() {
            if (!$(this).hasClass('bcfla-label-unchecked')) flags.push($(this).attr('data-flagid'))
        })

        var add: string = $(
            '.' + options.pageName + ' #' + options.pagePrefix + '-flagall-addordelete button.bcfla-checked',
        ).attr('data-value')

        var currentPage: string = $(
            '.' + options.pageName + ' #' + options.pagePrefix + '-flagall-currentpage button.bcfla-checked',
        ).attr('data-value')
        var households: string = $(
            '.' + options.pageName + ' #' + options.pagePrefix + '-flagall-households button.bcfla-checked',
        ).attr('data-value')
        var count: string = $('.' + options.pageName + ' #' + options.pagePrefix + '-flagall-count input').val()

        $ajax.post({
            loadingText: 'Sparar flaggning...',
            url: '/Owner/FlagMulti',
            data: {
                add: add,
                currentPage: currentPage,
                households: households,
                rowCount: count,
                page: common.currentPage,
                rowsperpage: common.displayedRowsPerPage,
                sortId: common.sortId,
                sortAsc: common.sortAsc,
                flags: flags.join(','),
                criteriaData: JSON.stringify(common.serializeForm()),
            },
            success: function(res) {
                common.getList(common.currentPage)
            },
        })
    }
}

export module transferform {
    var callQueue: JQuery = $({})

    export function init($options: common.IInitOptions): void {
        common.options = $options
        common.options.countUrl = '/Search/TransferCount'
        common.options.listUrl = '/Search/TransferList'

        $help.tooltips.initializeTooltips($('.' + $options.pageName))

        $helpers.scroll.actionWhenVisible(
            common.elem('buttonsplh'),
            (el) => {
                $('.bcfla-form-group-btn').removeClass('bcfla-form-group-btn--fixed')
            },
            (el) => {
                $('.bcfla-form-group-btn').addClass('bcfla-form-group-btn--fixed')
            },
        )

        common.formFields = [common.elem('region'), common.elem('county'), common.elem('freetext')]

        common.formFieldsReset = [
            common.elem('region'),
            common.elem('county'),
            common.elem('freetext'),
            common.elem('datefrom'),
            common.elem('dateto'),
            common.elem('area-min'),
            common.elem('area-max'),
            common.elem('sum-min'),
            common.elem('sum-max'),
        ]

        common.formCheckboxes = [common.elem('buytype'), common.elem('type')]

        common.formCheckboxesReset = [common.elem('buytype'), common.elem('type')]

        common.formFlags = []

        common.formSliders = [common.elem('area-slider'), common.elem('sum-slider')]

        common.formRanges = [
            [common.elem('area-min'), common.elem('area-max'), common.elem('area-slider')],
            [common.elem('sum-min'), common.elem('sum-max'), common.elem('sum-slider')],
        ]

        common.formCustomFields = [
            function() {
                var tbdatefrom: JQuery = common.elem('datefrom')
                var tbdateto: JQuery = common.elem('dateto')

                var obj = {
                    CriteriaId: tbdatefrom.attr('data-criteria-id'),
                    Values: tbdatefrom.val() + '|' + tbdateto.val(),
                    PreviousValues: tbdatefrom.attr('data-previous-value'),
                    Invert: false,
                }
                return obj
            },
        ]

        common.formCustomFieldsLoad = [
            function(searchData) {
                var tbdatefrom: JQuery = common.elem('datefrom')
                var tbdateto: JQuery = common.elem('dateto')

                var vals = $search.getCriteria(tbdatefrom, searchData).Values.split('|')

                tbdatefrom.val(vals[0])
                tbdateto.val(vals[1])

                return tbdatefrom
            },
        ]

        common.formCustomFieldsReset = []

        common.bindCountEventTextbox(common.elem('freetext'))
        common.bindCountEventTextbox(common.elem('datefrom'))
        common.bindCountEventTextbox(common.elem('dateto'))

        common.bindCountEventDropdown(common.elem('region'))
        common.bindCountEventDropdown(common.elem('county'))

        common.bindCountEventCheckbox(common.elem('buytype'))
        common.bindCountEventCheckbox(common.elem('type'))

        common.initRangeWithSlider(common.elem('area-slider'), common.elem('area-min'), common.elem('area-max'))
        common.initRangeWithSlider(common.elem('sum-slider'), common.elem('sum-min'), common.elem('sum-max'))

        common.init()
        common.fetchRegions(function() {
            // load latest search after regions have been fetched the first time
            // otherwise it could go:
            //   1 start to fetch all regions
            //   2 load latest search
            //   3 set regions from latest search
            //   4 all regions finishes loading and overwrites latest search regions
            common.loadLatestSearch('/Search/FetchLatestForTransfer')
        })

        $blogpostpopup.load(3)

        common
            .elem('type')
            .find('button')
            .on('click', () => {
                const cbltypeval: string = $form.getCheckboxlistValues(common.elem('type')).join(',')
                if (cbltypeval == '1') {
                    // only "helöverlåtelse" selected, then we can search in sum and buytype
                    common.elem('buytype').find('button').prop('disabled', false).removeClass('bcfla-btn--disabled')

                    common.elem('sum-min').prop('disabled', false)
                    common.elem('sum-max').prop('disabled', false)
                } else {
                    // noep
                    common
                        .elem('buytype')
                        .find('button')
                        .removeClass('bcfla-checked')
                        .prop('disabled', true)
                        .addClass('bcfla-btn--disabled')

                    common.elem('sum-min').prop('disabled', true).val('')
                    common.elem('sum-max').prop('disabled', true).val('')

                    common.count(common.elem('buytype'), true)
                    common.count(common.elem('sum-min'), true)
                }
            })
    }
}

export module transferlist {
    var options: any

    export function init($options: any): void {
        options = $.extend(true, {}, $options)

        $('.' + options.pageName + ' .bcfla-th-sortable').click(function() {
            common.setSort(parseInt($(this).attr('data-sortid')), $(this).attr('data-sortasc'))
            common.getList(1)
        })

        $('.' + options.pageName + ' .' + options.pagePrefix + '-td-date a').click(function() {
            $modal.load('/Default/TransferDetailsModal', { id: $(this).attr('data-id') }, true, true, true)
        })

        $helpers.partialPageInit($('.' + options.pageName))
    }
}

export module locationform {
    var callQueue: JQuery = $({})
    var map: google.maps.Map
    var mapMarker: google.maps.Marker
    var mapCircle: google.maps.Circle
    var defaultRadius: number = 1
    let searchTypeRadius: boolean = true
    let searchTypePolygon: boolean = false
    let mapCount: any
    let polygon: google.maps.Polygon
    let polyline: google.maps.Polyline
    let polymarkers: google.maps.Marker[] = []

    const polygonOptions = {
        strokeColor: '#0000ff',
        strokeOpacity: 0.4,
        strokeWeight: 2,
        fillColor: '#0000ff',
        fillOpacity: 0.1,
        zIndex: 950,
    }

    export function init($options: any): void {
        common.options = $options
        common.options.countUrl = '/Search/LocationCount'
        common.options.listUrl = '/Search/LocationList'
        defaultRadius = $options.defaultRadius

        $helpers.scroll.actionWhenVisible(
            common.elem('buttonsplh'),
            (el) => {
                $('.bcfla-form-group-btn').removeClass('bcfla-form-group-btn--fixed')
            },
            (el) => {
                $('.bcfla-form-group-btn').addClass('bcfla-form-group-btn--fixed')
            },
        )

        common.formFields = [common.elem('region'), common.elem('county')]

        common.formFieldsReset = [common.elem('region'), common.elem('county')]

        common.formCheckboxes = []

        common.formCheckboxesReset = []

        common.formFlags = []

        common.formSliders = []

        common.formRanges = []

        common.formCustomFields = [
            function() {
                var mapdiv: JQuery = common.elem('map')

                if (searchTypePolygon) {
                    const path = polyline.getPath().getArray()

                    const coords = 'p|' + path.map((n) => n.lat() + ':' + n.lng()).join('|')

                    const polygonArea = google.maps.geometry.spherical.computeArea(path)
                    const polygonAreaHectare = polygonArea / 10000
                    console.log('polygonArea ' + polygonArea + ' m^2')
                    console.log('polygonAreaHectare ' + polygonAreaHectare + ' ha')
                    common.elem('total-col-area').html(
                        Math.round(polygonAreaHectare)
                            .toString()
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' ha',
                    )

                    return {
                        CriteriaId: mapdiv.attr('data-criteria-id'),
                        Values: coords,
                        PreviousValues: mapdiv.attr('data-previous-value'),
                        Invert: false,
                    }
                }

                var radius: string = common.elem('radius-textbox').val()
                var radiusMeters: number = parseInt(radius) * 1000

                const circleArea = radiusMeters * radiusMeters * Math.PI
                const circleAreaHectare = circleArea / 10000
                console.log('circleArea ' + circleArea + ' m^2')
                console.log('circleAreaHectare ' + circleAreaHectare + ' ha')
                common.elem('total-col-area').html(
                    Math.round(circleAreaHectare)
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + ' ha',
                )

                var mapMarkerLat: number = 0
                var mapMarkerLng: number = 0
                if (mapMarker.getMap() !== undefined && mapMarker.getMap() !== null) {
                    mapMarkerLat = mapMarker.getPosition().lat()
                    mapMarkerLng = mapMarker.getPosition().lng()
                }

                return {
                    CriteriaId: mapdiv.attr('data-criteria-id'),
                    Values: mapMarkerLat + '|' + mapMarkerLng + '|' + radius,
                    PreviousValues: mapdiv.attr('data-previous-value'),
                    Invert: false,
                }
            },
        ]

        common.formCustomFieldsLoad = [
            function(searchData) {
                // ...

                return 0
            },
        ]

        common.formCustomFieldsReset = [
            function(searchData) {
                // ...
            },
        ]

        common.bindCountEventDropdown(common.elem('region'))
        common.bindCountEventDropdown(common.elem('county'))

        // search type radio
        common
            .elem('mapsearch-type')
            .find('button')
            .on('click', () => {
                setTimeout(() => {
                    const typeValues = $form.getCheckboxlistValues(common.elem('mapsearch-type'))

                    searchTypeRadius = typeValues.includes('radius')
                    searchTypePolygon = typeValues.includes('polygon')

                    if (searchTypeRadius) {
                        common.elem('radius-map-controls').show()
                        common.elem('polygon-map-controls').hide()
                        resetPolygonSearch()
                        mapCount = _.debounce(() => common.count(common.elem('map')), 500)
                    } else {
                        common.elem('radius-map-controls').hide()
                        common.elem('polygon-map-controls').show()
                        resetRadiusSearch()
                        mapCount = _.debounce(() => common.count(common.elem('map')), 2000) // slightly longer delay when creating polygon
                    }

                    mapCount()
                }, 100)
            })

        // radius tb/slider
        {
            common.elem('radius-textbox').on('blur keyup', function() {
                mapCircle.setRadius(parseInt($(this).val()) * 1000)
                common.elem('radius-slider').slider('value', $(this).val())
                mapCount()
            })

            common.elem('radius-slider').slider({
                value: defaultRadius,
                min: 1,
                max: 100,
                step: 1,
                slide: function(event, ui: any) {
                    common.elem('radius-textbox').val(ui.value)
                    mapCircle.setRadius(ui.value * 1000)
                },
                stop: function(event, ui) {
                    mapCount()
                },
            })
        }

        // property search
        {
            const propertySearch = () => {
                $ajax.post({
                    loadingText: 'Söker...',
                    url: '/Search/LocationByPropertyName',
                    data: {
                        property: common.elem('position-search').val(),
                    },
                    success: (res: any) => {
                        if (res.Ok) {
                            setPosition(new google.maps.LatLng(res.Lat, res.Long))
                        } else {
                            $msg.showError(
                                `Din sökning på "${common
                                    .elem('position-search')
                                    .val()}" matchade inga fastighetsområden i vårt register.`,
                            )
                        }
                    },
                })
            }

            $helpers.onEnter(common.elem('position-search'), propertySearch)
            common.elem('position-search-btn').click(propertySearch)

            common.elem('position-search').autocomplete({
                source: '/Search/PropertyNameAutoComplete',
                minLength: 2,
                select: function(event, ui) {
                    common.elem('position-search').val(ui.item.value)
                    common.elem('position-search').trigger('enter')
                },
                autoFocus: true,
                delay: 200,
                appendTo: '.' + common.options.pagePrefix + '-search-box',
            })
        }

        // init map
        {
            mapCount = _.debounce(() => common.count(common.elem('map')), 500)

            var initMapOptions = <$maps.IInitMapOptions>{
                mapElement: common.elem('map'),
                mapId: 'searchmap',
                mapOptions: {
                    zoom: 11,
                },
            }

            if ($options.mapCenter) initMapOptions.mapOptions.center = $options.mapCenter

            map = $maps.initMap(initMapOptions)

            google.maps.event.addListener(map, 'click', (event) => {
                handleClick(event)
            })
        }

        // radius specific
        {
            mapMarker = new google.maps.Marker({
                draggable: true,
                zIndex: 1100,
            })

            mapCircle = new google.maps.Circle({
                strokeColor: '#0000ff',
                strokeOpacity: 0.4,
                strokeWeight: 2,
                fillColor: '#0000ff',
                fillOpacity: 0.1,
                radius: defaultRadius * 1000,
                zIndex: 900,
            })

            if ($options.mapCenter) setPosition($options.mapCenter)

            google.maps.event.addListener(mapMarker, 'dragend', function(event) {
                if (!searchTypeRadius) return
                mapCircle.setMap(map)
                mapCircle.setCenter(event.latLng)
                map.setCenter(event.latLng)
                mapCount()
            })
        }

        // polygon specific
        {
            polyline = new google.maps.Polyline(polygonOptions)
            polyline.setMap(map)

            common.elem('polygon-reset').on('click', () => {
                resetPolygonSearch()
                updatePolygonCoordinates()
            })

            common.elem('polygon-undo').on('click', () => {
                const lastMarker = polymarkers.pop()
                if (!lastMarker) return
                lastMarker.setMap(null)

                const path = polyline.getPath()
                path.removeAt(path.getLength() - 1)

                updatePolygonCoordinates()
            })
        }

        // init owner flags
        {
            common.elem('flagall-addordelete button').click(function() {
                var addTo = $(this).attr('data-value') == 'true'
                if (addTo) {
                    common
                        .elem('flagall-households .' + common.options.pagePrefix + '-flagall-addordeletelabel-addto')
                        .removeClass('bcfla-hidden')
                    common
                        .elem(
                            'flagall-households .' + common.options.pagePrefix + '-flagall-addordeletelabel-deletefrom',
                        )
                        .addClass('bcfla-hidden')
                } else {
                    common
                        .elem('flagall-households .' + common.options.pagePrefix + '-flagall-addordeletelabel-addto')
                        .addClass('bcfla-hidden')
                    common
                        .elem(
                            'flagall-households .' + common.options.pagePrefix + '-flagall-addordeletelabel-deletefrom',
                        )
                        .removeClass('bcfla-hidden')
                }
            })

            common.elem('flagall-flags span').click(function() {
                $(this).toggleClass('bcfla-label-unchecked')
                setTimeout(function() {
                    checkFlagAllSelected()
                }, 200)
            })

            common.elem('flagall-submit').click(function() {
                submitFlagAll()
            })

            $flag.bindToggleFlagEvents($('.' + common.options.pagePrefix + '-flags-box'))
        }

        // init property flags
        {
            common.elem('flagallprop-addordelete button').click(function() {
                var addTo = $(this).attr('data-value') == 'true'
                if (addTo) {
                    common
                        .elem(
                            'flagallprop-households .' +
                            common.options.pagePrefix +
                            '-flagallprop-addordeletelabel-addto',
                        )
                        .removeClass('bcfla-hidden')
                    common
                        .elem(
                            'flagallprop-households .' +
                            common.options.pagePrefix +
                            '-flagallprop-addordeletelabel-deletefrom',
                        )
                        .addClass('bcfla-hidden')
                } else {
                    common
                        .elem(
                            'flagallprop-households .' +
                            common.options.pagePrefix +
                            '-flagallprop-addordeletelabel-addto',
                        )
                        .addClass('bcfla-hidden')
                    common
                        .elem(
                            'flagallprop-households .' +
                            common.options.pagePrefix +
                            '-flagallprop-addordeletelabel-deletefrom',
                        )
                        .removeClass('bcfla-hidden')
                }
            })

            common.elem('flagallprop-flags span').click(function() {
                $(this).toggleClass('bcfla-label-unchecked')
                setTimeout(function() {
                    checkFlagAllPropertySelected()
                }, 200)
            })

            common.elem('flagallprop-submit').click(function() {
                submitFlagAllProperty()
            })

            $flag.bindToggleFlagEvents($('.' + common.options.pagePrefix + '-flags-owner'))
            $flag.bindToggleFlagEvents($('.' + common.options.pagePrefix + '-flags-property'))
        }

        // ladda-ner-knappar
        common.elem('submit-dropdown-button-address-all').click(function() {
            showGetFileModal('false', 'false', false)
        })
        common.elem('submit-dropdown-button-address-allgdpr').click(function() {
            showGetFileModal('false', 'false', true)
        })
        common.elem('submit-dropdown-button-address-one').click(function() {
            showGetFileModal('false', 'true', false)
        })
        common.elem('submit-dropdown-button-address-onegdpr').click(function() {
            showGetFileModal('false', 'true', true)
        })
        common.elem('submit-dropdown-button-phone-all').click(function() {
            showGetFileModal('true', 'false', false)
        })
        common.elem('submit-dropdown-button-phone-allgdpr').click(function() {
            showGetFileModal('true', 'false', true)
        })
        common.elem('submit-dropdown-button-phone-one').click(function() {
            showGetFileModal('true', 'true', false)
        })
        common.elem('submit-dropdown-button-phone-onegdpr').click(function() {
            showGetFileModal('true', 'true', true)
        })

        // transfer results to flag
        common.elem('transfer-to-owner').click(function() {
            // get columns from localstorage to save in tempflag
            const columnsFromLocalStorage = localStorage.getItem('columns_bcfla-pg-sea-ownerform') || ''

            $ajax.post({
                loadingText: 'Flyttar över sökresultat...',
                url: '/Owner/SaveLocationSearchToTempFlag',
                data: {
                    criteriaData: JSON.stringify(common.serializeForm()),
                    totalNo: common.elem('total-no-owner').html(),
                    columns: columnsFromLocalStorage,
                },
                success: function(res) {
                    if (res.Ok) {
                        location.href = '/Search/OwnerForm'
                    } else {
                        $msg.showError(res.Message)
                    }
                },
            })
        })

        common.elem('transfer-to-property').click(function() {
            // get columns from localstorage to save in tempflag
            const columnsFromLocalStorage = localStorage.getItem('columns_bcfla-pg-sea-propertyform') || ''

            $ajax.post({
                loadingText: 'Flyttar över sökresultat...',
                url: '/Property/SaveLocationSearchToTempFlag',
                data: {
                    criteriaData: JSON.stringify(common.serializeForm()),
                    totalNo: common.elem('total-no-owner').html(),
                    columns: columnsFromLocalStorage,
                },
                success: function(res) {
                    if (res.Ok) {
                        location.href = '/Search/PropertyForm'
                    } else {
                        $msg.showError(res.Message)
                    }
                },
            })
        })

        common.init()
        common.fetchRegions(function() {
            // load latest search after regions have been fetched the first time
            // otherwise it could go:
            //   1 start to fetch all regions
            //   2 load latest search
            //   3 set regions from latest search
            //   4 all regions finishes loading and overwrites latest search regions
            common.loadLatestSearch('/Search/FetchLatestForLocation')
        })

        $blogpostpopup.load(4)
    }

    function showGetFileModal(includePhone: string, onlyOnePerHousehold: string, gdprSafe: boolean): void {
        if (gdprSafe) {
            $modal.show(
                '<h4>Observera</h4><p>Du är nu i färd med att exportera data ur Lantbruksfakta Digital.</p><p>Du har valt en GDPR-säkrad export med aktuell utmärkning av personer som har nixade telefonnummer alt. reklamspärr på postala adressen.</p><p>All exporterad data loggas och debiteras/faktureras enligt gällande prislista.</p><p>I detta val tillkommer även en fast avgift på 350 kr per export samt 0,3 kr per exporterad post.</p><p>Innan du fortsätter - kontrollera att det är korrekt urval och korrekt antal du nu vill exportera.</p><p><button class="bcfla-btn bcfla-btn-primary bcfla-btn-sm" onclick="bcfla.search.locationform.getFile(\'' +
                includePhone +
                "','" +
                onlyOnePerHousehold +
                '\',\'true\')">Fortsätt exporten</button><button class="bcfla-btn bcfla-btn-primary bcfla-btn-sm" onclick="$modal.hide()">Avbryt</button></p>',
                false,
            )
        } else {
            $modal.show(
                '<h4>Observera</h4><p>Du är nu i färd med att exportera data ur Lantbruksfakta Digital.</p><p>All exporterad data loggas och debiteras/faktureras enligt gällande prislista.</p><p>Innan du fortsätter - kontrollera att det är korrekt urval och korrekt antal du nu vill exportera.</p><p><button class="bcfla-btn bcfla-btn-primary bcfla-btn-sm" onclick="bcfla.search.locationform.getFile(\'' +
                includePhone +
                "','" +
                onlyOnePerHousehold +
                '\',\'false\')">Fortsätt exporten</button><button class="bcfla-btn bcfla-btn-primary bcfla-btn-sm" onclick="$modal.hide()">Avbryt</button></p>',
                false,
            )
        }
    }

    export function getFile(includePhone: string, onlyOnePerHousehold: string, gdprSafe: string): void {
        var f = (function() {
            callQueue.queue(function(next) {
                $modal.show('Sparar sökresultat till fil...')

                $ajax.post({
                    loadingText: 'Sparar sökresultat till fil...',
                    url: '/Export/LocationFile',
                    data: {
                        criteriaData: JSON.stringify(common.serializeForm()),
                        totalNo: common.elem('total-no-owner').html(),
                        phone: includePhone,
                        onlyOnePerHousehold: onlyOnePerHousehold,
                        gdprSafe: gdprSafe,
                    },
                    success: function(res) {
                        if (res.Ok) {
                            if (res.OverLimit) {
                                $modal.show(
                                    '<h4>Export startad</h4><p>Ditt data håller på att exporteras. Pga datamängden behöver detta först godkännas av en administratör. När det är gjort, kommer du få ett mail med en länk till din fil.</p><p>Har du frågor kring detta - kontakta supporten på <a href="tel:0707254618">070-725 46 18</a> eller maila oss på <a href="mailto:camo@biscom.se">camo@biscom.se</a>.</p><p>Mvh<br/>LantbruksFaktaDigital / Biscom<br/><a href="http://www.lantbruksfaktadigital.se">www.lantbruksfaktadigital.se</a><br/>Carl-Johan Mossberg<br/><a href="tel:0707254618">070-725 46 18</a><br/><a href="mailto:camo@biscom.se">camo@biscom.se</a></p>',
                                    true,
                                    false,
                                )
                            } else if (res.GdprSafe) {
                                $modal.show(
                                    '<h4>Export startad</h4><p>Ditt data håller på att exporteras. När det är klart, kommer du få ett mail med en länk till din fil.</p><p>Har du frågor kring detta - kontakta supporten på <a href="tel:0707254618">070-725 46 18</a> eller maila oss på <a href="mailto:camo@biscom.se">camo@biscom.se</a>.</p><p>Mvh<br/>LantbruksFaktaDigital / Biscom<br/><a href="http://www.lantbruksfaktadigital.se">www.lantbruksfaktadigital.se</a><br/>Carl-Johan Mossberg<br/><a href="tel:0707254618">070-725 46 18</a><br/><a href="mailto:camo@biscom.se">camo@biscom.se</a></p>',
                                    true,
                                    false,
                                )
                            } else {
                                $modal.show(
                                    '<h4>Export startad</h4><p>Ditt data håller på att exporteras. När det är klart, kommer du få ett mail med en länk till din fil.</p><p>Har du frågor kring detta - kontakta supporten på <a href="tel:0707254618">070-725 46 18</a> eller maila oss på <a href="mailto:camo@biscom.se">camo@biscom.se</a>.</p><p>Mvh<br/>LantbruksFaktaDigital / Biscom<br/><a href="http://www.lantbruksfaktadigital.se">www.lantbruksfaktadigital.se</a><br/>Carl-Johan Mossberg<br/><a href="tel:0707254618">070-725 46 18</a><br/><a href="mailto:camo@biscom.se">camo@biscom.se</a></p>',
                                    true,
                                    false,
                                )
                            }
                        } else {
                            $modal.hide()
                            $msg.showError(res.Message)
                        }
                    },
                    complete: function() {
                        next()
                    },
                })
            })
        })()
    }

    function checkFlagAllSelected() {
        var flagged = 0
        common.elem('flagall-flags span').each(function() {
            if (!$(this).hasClass('bcfla-label-unchecked')) flagged++
        })
        common.elem('flagall-submit').prop('disabled', flagged === 0)
    }

    function checkFlagAllPropertySelected() {
        var flagged = 0
        common.elem('flagallprop-flags span').each(function() {
            if (!$(this).hasClass('bcfla-label-unchecked')) flagged++
        })
        common.elem('flagallprop-submit').prop('disabled', flagged === 0)
    }

    function submitFlagAll() {
        var flags: string[] = []
        common.elem('flagall-flags span').each(function() {
            if (!$(this).hasClass('bcfla-label-unchecked')) flags.push($(this).attr('data-flagid'))
        })

        var add: string = common.elem('flagall-addordelete button.bcfla-checked').attr('data-value')

        var households: string = common.elem('flagall-households button.bcfla-checked').attr('data-value')

        $ajax.post({
            loadingText: 'Sparar flaggning...',
            url: '/Owner/FlagMultiByLocation',
            data: {
                add: add,
                households: households,
                flags: flags.join(','),
                criteriaData: JSON.stringify(common.serializeForm()),
                saveHistory: true,
            },
            success: function(res) {
                $msg.show(res.Message, res.IsOk)
            },
        })
    }

    function submitFlagAllProperty() {
        var flags: string[] = []
        common.elem('flagallprop-flags span').each(function() {
            if (!$(this).hasClass('bcfla-label-unchecked')) flags.push($(this).attr('data-flagid'))
        })

        var add: string = common.elem('flagallprop-addordelete button.bcfla-checked').attr('data-value')

        $ajax.post({
            loadingText: 'Sparar flaggning...',
            url: '/Property/FlagMultiByLocation',
            data: {
                add: add,
                flags: flags.join(','),
                criteriaData: JSON.stringify(common.serializeForm()),
                saveHistory: true,
            },
            success: function(res) {
                $msg.show(res.Message, res.IsOk)
            },
        })
    }

    function setPosition(pos: google.maps.LatLng): void {
        map.setCenter(pos)

        if (searchTypePolygon) {
            resetPolygonSearch()
        } else {
            checkRadius()
            mapCircle.setMap(map)
            mapCircle.setCenter(pos)
            common.elem('submit-dropdown-toggle-address').prop('disabled', false)
            common.elem('submit-dropdown-toggle-phone').prop('disabled', false)
        }

        console.log('mapMarker.setMap(map)')
        mapMarker.setMap(map)
        mapMarker.setPosition(pos)

        mapCount()
    }

    function checkRadius(): void {
        var rad = <string>common.elem('radius-textbox').val()
        if (rad.length === 0 || parseInt(rad) <= 0) {
            common.elem('radius-textbox').val(defaultRadius.toString())
            mapCircle.setRadius(defaultRadius * 1000)
            common.elem('radius-slider').slider('value', defaultRadius)
        }
    }

    function handleClick(event: any): void {
        if (searchTypeRadius) setPosition(event.latLng)
        else addPolygonNode(event)
    }

    function addPolygonNode(event: any) {
        const path = polyline.getPath()

        if (path.getLength() == 2) {
            polygon = new google.maps.Polygon({
                path: path,
                ...polygonOptions,
            } as google.maps.PolygonOptions)
            polygon.setMap(map)
        }

        path.push(event.latLng)
        let index = -1

        function dragStartEvent(event: any) {
            const arr = path.getArray()
            index = arr.indexOf(event.latLng)
        }

        function dragEndEvent(event: any) {
            if (index < 0) return
            path.setAt(index, event.latLng)
            updatePolygonCoordinates()
        }

        // not ready for prime time - since the markers hold a reference to their index, it all shifts into wrong position when one marker is removed
        //function removeNode(marker: google.maps.Marker) {
        //    let index = marker.getZIndex() - 1000
        //    console.log('marker.getZIndex() ' + marker.getZIndex() + ', index ' + index)
        //    path.removeAt(index)
        //    marker.setMap(null)
        //}

        let markerColor = '#aa0000'
        if (path.getLength() === 1) markerColor = '#dd0000' // make the first marker slightly brighter

        const marker = new google.maps.Marker({
            position: event.latLng,
            title: '#' + path.getLength(),
            map: map,
            draggable: true,
            zIndex: 1000 + path.getLength() - 1,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: markerColor,
                fillOpacity: 0.8,
                strokeColor: markerColor,
                strokeWeight: 2,
                scale: 6,
            } as any,
        })

        polymarkers.push(marker)

        marker.addListener('dragstart', dragStartEvent)
        marker.addListener('dragend', dragEndEvent)
        //marker.addListener('dblclick', () => removeNode(marker))

        updatePolygonCoordinates()
    }

    function updatePolygonCoordinates() {
        //const path = polyline.getPath()
        //console.log(path.getArray())

        mapCount()
    }

    function resetRadiusSearch(resetMarker = false) {
        if (resetMarker) mapMarker.setMap(null)
        mapCircle.setMap(null)
    }

    function resetPolygonSearch(resetMarker = false) {
        if (resetMarker) mapMarker.setMap(null)

        polyline?.setMap(null)
        polygon?.setMap(null)

        polyline = null
        polygon = null

        polyline = new google.maps.Polyline(polygonOptions)
        polyline.setMap(map)

        polymarkers.forEach((marker) => marker.setMap(null))
        polymarkers = []
    }
}

export module locationlist {
    var options: any

    export function init($options: any): void {
        options = $.extend(true, {}, $options)

        $helpers.partialPageInit($('.' + options.pageName))
    }
}

export module savedsearchlist {
    export interface IInitOptions {
        pageName: string
        pagePrefix: string
        typeId: number
        sortId: number
        sortAsc: boolean
        callback: any
    }

    export function init($options: IInitOptions): void {
        new savedsearchlistInstance($options)
    }

    export class savedsearchlistInstance {
        private options: IInitOptions
        private sortId: number
        private sortAsc: boolean

        constructor(opts: IInitOptions) {
            var self = this

            self.options = $.extend(true, {}, opts)

            self.sortId = self.options.sortId
            self.sortAsc = self.options.sortAsc

            $('.' + self.options.pageName + ' .bcfla-th-sortable').click(function() {
                self.setSort(parseInt($(this).attr('data-sortid')), $(this).attr('data-sortasc'))
                self.getList()
            })

            $('.' + self.options.pageName + ' .' + self.options.pagePrefix + '-btn-delete').click(function() {
                if (!confirm('Är du säker på att du vill ta bort denna sökfråga?')) return
                self.getList($(this).attr('data-id'), 'Raderar...')
            })
        }

        private setSort(newSort: number, asc: string): void {
            var self = this

            if (newSort != self.sortId) {
                self.sortId = newSort
                self.sortAsc = asc == 'true'
            } else {
                self.sortAsc = !self.sortAsc
            }
        }

        private getList(deleteId: string = '-1', loading: string = 'Hämtar...') {
            var self = this

            $loading.show(loading)

            $('.' + self.options.pageName).load(
                '/Search/SavedSearchList?delete=' +
                deleteId +
                '&sort=' +
                self.sortId +
                '&asc=' +
                self.sortAsc +
                '&type=' +
                self.options.typeId,
                function() {
                    $loading.hide()
                },
            )
        }
    }
}

export module quicksearch {
    export interface IInitOptions {
        pageName: string
        pagePrefix: string
    }

    var options: IInitOptions

    let tb: JQuery
    let list: JQuery
    let closeicon: JQuery
    let q: JQueryXHR | null = null
    let prev = 'n/a'
    let prevPage = 1
    let totalPages = 1

    export function init($options: IInitOptions): void {
        options = $.extend(true, {}, $options)

        $helpers.partialPageInit($('.' + options.pageName))
        $help.tooltips.initializeTooltips($('.' + options.pageName))

        tb = $('.' + options.pageName + ' .' + options.pagePrefix + '__text')
        list = $('#bcfla-quicksearchlist')

        closeicon = $('.' + options.pageName + ' .closeicon')
        closeicon.click(() => {
            tb.val('')
            list.html('').hide()
            closeicon.hide()
        })

        const arrowPress = (offset: number) => {
            const trs = list.find('tbody tr')
            const selidx = trs.filter('.selectedqsrow').index()
            let newidx = selidx + offset
            if (newidx >= trs.length) newidx = 0
            trs.eq(selidx).removeClass('selectedqsrow')
            trs.eq(newidx).addClass('selectedqsrow')
        }

        tb.on('keyup change blur', function(event: JQueryEventObject) {
            var code = event.keyCode || event.which

            if (code == 27) {
                // esc
                tb.val('').blur()
                list.html('').hide()
                return
            } else if (code == 13) {
                // enter
                const link = list.find('tbody tr.selectedqsrow a').attr('data-link')
                $modal.load(link, { edit: 'notes' }, false, true, true)
                return
            } else if (code == 37) {
                // arrow left
                let newPage = prevPage - 1
                if (newPage < 1) newPage = 1
                getList(newPage)
                return
            } else if (code == 39) {
                // arrow right
                let newPage = prevPage + 1
                if (newPage > totalPages) newPage = totalPages
                getList(newPage)
                return
            } else if (code == 38) {
                // arrow up
                arrowPress(-1)
                return
            } else if (code == 40) {
                // arrow down
                arrowPress(1)
                return
            }

            setTimeout(() => {
                if (tb.val().length == 0) {
                    closeicon.hide()
                    list.html('').hide()
                    return
                }

                closeicon.show()
                getList(1)
            }, 100)
        })

        tb.focus(() => {
            if (tb.val().length > 0) {
                closeicon.show()
                getList(prevPage)
            }
        })
    }

    export function setTotalPages(pages: number): void {
        totalPages = pages
    }

    export function getList(page: number): void {
        const search = tb.val()

        if (search == prev && page == prevPage) return

        if (q) q.abort()

        prev = search
        prevPage = page

        q = $ajax.get({
            url: '/searchv2/quicksearchlist?search=' + encodeURIComponent(search) + '&page=' + page,
            dataType: 'html',
            success: (res) => {
                list.show().html(res)

                list.find('.namelink').click(function(e) {
                    var url = $(this).attr('data-link')
                    $modal.load(url, { edit: 'notes' }, false, true, true)
                    e.preventDefault()
                })

                $loading.hide()

                q = null
                prev = search
                prevPage = page
            },
        })
    }
}
